import React, { useState, useEffect, useCallback, Fragment, PureComponent, useMemo } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classNames from 'classnames';
import styled from 'styled-components';
//dev component
import { PC_RECEIPT_GREETING } from '../../../common/constants';
import DropDown from '../../../components/DropDown';
import FileUploader from '../../../components/FileUploader';
import WorkingHours from '../../../components/v5/WorkingHours';
import BreakHours from '../../../components/v5/BreakHours';
import CloseReceipt from '../../../components/CloseReceipt';
import FeedbackSettings from '../../../components/FeedbackSettings';
import OpenExternalV5 from '../../../components/v5/ExternalSystem';
import BrightSettingV5 from '../../../components/v5/BrightSetting';
import ArtificialSettingV5 from '../../../components/v5/ArtificialSol';
import Ckeditor from '../../../components/v5/Ckeditor';
import CKEditor5Component from '../../../components/CKEditor5Component';
import AreaTableEdit from './tableEdit';
//FLUX actions and store
import AdminAction from '../../../flux/actions/adminActions';
import AdminStore from '../../../flux/stores/adminStore';
//feature
import Feature from '../../../components/v5/Feature';
import CFlag, { Hideable } from '../../../reactcomponents/CFlag';
import SwitchCheckbox from '../../../reactcomponents/SwitchCheckbox';
import { SelectInputRow, FormInputWithLabelRow, CheckboxInputRow, TextInputRow } from '../../../reactcomponents/Form';
import { SingleSelectDD } from '../../../reactcomponents/Dropdown';
import {
	formatValueToNameObj
} from '../../../common/v5/helpers';
import { SaveButton, CancelButton, RightEndHelper as Helper, ListContentWrapper, ActionsWrapper, Edit, Remove, ACTION_DELETE } from '../../../reactcomponents/Admin';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { SkillUpdateModal, AddAgentBtnStyle } from '../../v5/skills/Skills';
import { DeletePopup } from '../../../reactcomponents/Dialog';
import { customPageTotal } from '../../../reactcomponents/Table'
import { BTN_TXT_SAVE, BTN_TXT_SAVING } from '../../../common/v5/constants';
import { AlertWrapper } from '../../v5/admin';
import { DismissableAlert } from '../../../reactcomponents/Error';
import { I, L } from '../../../common/v5/config';
import { getCKEditorFlag } from '../../../common/globals';
import { centionBlue } from '../../../styles/_variables';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ActionFlowForm } from '../../../reactcomponents/Chatbot';

global.AREA = 1, global.WORKINGHOUR = 2, global.CLOSERECEIPT = 3, global.OPENEXTERNAL = 4, global.FEEDBACK = 5, global.BRIGHT = 6, global.ARTIFICIALSOL = 7;
global.CONVERSATIONBOTWORKINGHOUR = 8, global.AREAROUTING = 9, global.AREAREPLACEMENT = 10, global.AREAAUTOFORWARD = 11, global.AREASMS = 12,
global.AREAFORWARDEXTERNAL = 13, global.AREASKILLS = 14,
global.BREAKHOURS = 15, global.CONVBOTBREAKHOURS=16, global.AREA_AI_SETTINGS=17;

const CHATBOT_ACTION_OPTIONS = [
	{ id: 1, name: I("AI Agent"), actionType: "actionTools" }, //call an endpoint that setup in the action tools (AI Agent Builder)
	{ id: 2, name: I("URL"), actionType: "url" },  // a hyperlink
	{ id: 3, name: I("Text"), actionType: "text" }, //as a shortcut for a prompt
	{ id: 4, name: I("Sub actions"), actionType: "button" }, //to show another set of actions after click
	{ id: 5, name: I("Handover"), actionType: "handover" }, //to confirm handover process
]

// Added CHATBOT_PERSONALITY definition
const CHATBOT_PERSONALITY = [
	{ id: 1, name: I("Casual") },
	{ id: 2, name: I("Formal") },
]

const SkillTableOptions = {
	paginationSize: 3,
	pageStartIndex: 1,
	hideSizePerPage: true, // Hide the sizePerPage dropdown always
	hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
	firstPageText: '<<',
	prePageText: '<',
	nextPageText: '>',
	lastPageText: '>>',
	showTotal: true,
	paginationTotalRenderer: customPageTotal,
	disablePageTitle: true,
	sizePerPageList: [10] //todo: give user the option to choose instead of fixed value
};

const renderSkillActions = (
	cell
	, { id, skillId, proficiency }
	, { onDelete, onEdit }
) => {
	return (
		<ActionsWrapper>
			{onEdit && <Edit id={id} onClick={() => onEdit(id, skillId, proficiency)} />}
			{onDelete && <Remove
				id={id}
				onClick={(() => onDelete(id))}
			/>}
		</ActionsWrapper>
	)
}

const grid = 8;
const getItemStyle = (isDragging, draggableStyle) => ({
	userSelect: "none ",
	padding: grid * 2,
	margin: `0 0 ${grid}px 0`,
	background: isDragging ? "lightgreen" : "grey",
	...draggableStyle
});

export default function OrganisationEdit(props) {
	const { id, onCloseEdit, skillList } = props;
	const [title, setTitle] = useState(I("Add new area"));
	const [activeTab, setActiveTab] = useState(AREA);
	const [area, setArea] = useState({});
	const [user, setUser] = useState({}); // Assuming this might be populated later
	const [saving, setSaving] = useState(false);
	const [tabPage, setTabPage] = useState(1);
	const [openSkillModal, setOpenSkillModal] = useState(false);
	const [activeSkillModal, setActiveSkillModal] = useState({});
	const [activeAreaSkill, setActiveAreaSkill] = useState(0);
	const [showDeleteAlert, setShowDeleteAlert] = useState(false);
	const [toBeDeleted, setToBeDeleted] = useState(0);
	const [copyTriggered, setCopyTriggered] = useState(false);
	const [pasteEnabled, setPasteEnabled] = useState(false);
	const [copyData, setCopyData] = useState(AdminStore.state.copyData || {});
	const [copyIconColor, setCopyIconColor] = useState('#6D6D6D');
	const [pasteIconColor, setPasteIconColor] = useState('#6D6D6D');
	const [copyHoverText, setCopyHoverText] = useState('Copy');
    const [pasteHoverText, setPasteHoverText] = useState('Paste');
	const [actionForms, setActionForms] = useState([]);
	const [expandAction, setExpandAction] = useState(false); //may not used anymore in this component

	const onFluxStoreChange = useCallback((state) => {
		const states = state.areaConf;
		if (states && states.area) {
			setArea(states.area);
			setCopyData(state.copyData || {});
		}
		if (states && states.area && states.area.actionFlow) {
			setActionForms(JSON.parse(states.area.actionFlow));
		}
	}, []);

	useEffect(() => {
		AdminStore.listen(onFluxStoreChange);
		let orgId = props.orgId !== undefined ? props.orgId : 0;
        AdminAction.getAreaById(props.id, orgId);

		if (props.id >= 1) {
			setTitle(I("Edit area"));
		}

		return () => {
			AdminStore.unlisten(onFluxStoreChange);
		};
	}, [props.id, props.orgId, onFluxStoreChange]);

    // Effect to handle logic from componentDidUpdate related to title changes
    useEffect(() => {
        if (title === I("Add new area")) {
            // Reset form state ONLY when title changes TO "Add new area"
            // setCopyData({}); // Keep copyData available for paste
            setArea({});
            setPasteHoverText('Paste');
            setPasteIconColor('#6D6D6D');
            // Optionally set paste button enabled state based on copyData
            setPasteEnabled(!!copyData?.data && Object.keys(copyData.data).length > 0);
        } else if (title === I("Edit area")) {
            // Reset copy button state when switching TO "Edit area"
             setCopyHoverText('Copy');
             setCopyIconColor('#6D6D6D');
             setCopyTriggered(false);
             setPasteEnabled(false); // Disable paste button in Edit mode
        }
        // This effect primarily manages state resets and button appearances based on the mode (title)
        // and the availability of data to paste (copyData.data)
    }, [title, copyData.data]); // << REMOVED 'area' dependency

	const toggle = useCallback((tab) => {
		if (tab === AREASKILLS) {
			//fetching necessary skills stuff
			if(props.onLoadAreaSkillsTab) {
				props.onLoadAreaSkillsTab(props.id);
			}
		}
		if (activeTab === AREA && props.id <= 0) {
			return;
		}
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	}, [activeTab, props.id, props.onLoadAreaSkillsTab]);

	const handleCopyData = useCallback(() => {
		if (title === I("Edit area")) {
			AdminAction.setCopyData(area);
			setCopyTriggered(true);
			setCopyIconColor('#0C87F7');
			setCopyHoverText('Copied');
            // The console log depends on the state update which is async
            // To log the *updated* state, you might need an effect or log the `area` directly
            // console.log("Data copied:", area);
		}
	}, [title, area]);

	const handlePasteData = useCallback(() => {
		if (title === I("Add new area") && copyData && copyData.data) {
            const dataToPaste = { ...copyData.data };
            // Consider if ID needs removal before setting state, depends on backend logic
            // delete dataToPaste.id; 
			setArea(dataToPaste);
			setPasteEnabled(false); // Disable paste button after successful paste
			setPasteIconColor('#0C87F7'); // Indicate success
			setPasteHoverText('Pasted');
            // The console log depends on the state update which is async
            // To log the *updated* state, you might need an effect
            // console.log("Data pasted:", copyData.data);
		}
	}, [title, copyData, setArea, setPasteEnabled, setPasteIconColor, setPasteHoverText]); // Added setters to dependency array

	const handleSaveArea = useCallback((ActionId, values) => {
		setSaving(true);
		AdminAction.saveAdminArea(props.id, values)
			.then((data) => {
				setSaving(false);
				props.onCloseEdit();
			})
            .catch(() => {
                // Added basic error handling
                setSaving(false);
                props.onCloseEdit(); // Still close on error as per original logic
            });
	}, [props.id, props.onCloseEdit]);

	const handleSaveAreaExternal = useCallback((ActionId, values, areaId, orgId) => {
		setSaving(true);
		AdminAction.saveAdminArea(props.id, values)
			.then((data) => {
				setSaving(false);
				AdminAction.getAreaById(areaId, orgId);
			})
            .catch(() => {
                // Added basic error handling
                setSaving(false);
                // Consider if additional error handling/logging is needed
            });
	}, [props.id]);

	const handleCancelToOrg = useCallback(() => {
		window.location.hash = "#organisations";
	}, []);

	const handleWorkingException = useCallback((values) => {
		AdminAction.saveAreaException(props.id, values)
			.then(() => {
				console.log("Working exception saved.");
			})
            .catch(error => {
                console.error("Error saving working exception:", error);
            });
	}, [props.id]);

	const handleChangeTab = useCallback((tab) => {
		let nextPage = tabPage;
		if (tab) {
			nextPage = tab;
		}
		const newTabPage = nextPage === 1 ? 2 : 1;
        const newActiveTab = newTabPage === 1 ? AREA : AREAREPLACEMENT;
        setTabPage(newTabPage);
        setActiveTab(newActiveTab);
	}, [tabPage]);

	const handleOpenSelectSkillModal = useCallback(() => {
		setOpenSkillModal(true);
	}, []);

	const handleCloseSkillModal = useCallback(() => {
		setOpenSkillModal(false);
		setActiveAreaSkill(0);
		setActiveSkillModal({
			skill: 0,
			proficiency: 0
		});
	}, []);

	const handleSaveSkill = useCallback((skillId, proficiencyId) => {
		const params = {
			id: activeAreaSkill,
			areaId: props.id,
			skillId,
			proficiencyId
		};
		if(props.onSaveAreaSkill) {
			props.onSaveAreaSkill(params);
		}
        // No need to set state here as per original logic, assuming parent handles it
        //setActiveSkillModal({ skill: 0, proficiency: 0 });
        //setActiveAreaSkill(0);
        handleCloseSkillModal(); // Close modal after save attempt
	}, [activeAreaSkill, props.id, props.onSaveAreaSkill, handleCloseSkillModal]);

	const handleEditAreaSkill = useCallback((id, skill, proficiency) => {
		setActiveSkillModal({
			skill: skill,
			proficiency: proficiency,
			id: id
		});
        setActiveAreaSkill(id);
        setOpenSkillModal(true);
	}, []);

	const handleDeleteAreaSkill = useCallback((id) => {
		setShowDeleteAlert(true);
        setToBeDeleted(id);
		if(openSkillModal) {
			handleCloseSkillModal();
		}
	}, [openSkillModal, handleCloseSkillModal]);

	const handleConfirmDelete = useCallback(() => {
		props.onDeleteAreaSkill(toBeDeleted);
		setShowDeleteAlert(false);
        setToBeDeleted(0);
	}, [props.onDeleteAreaSkill, toBeDeleted]);

	const handleCancelDelete = useCallback(() => {
		setShowDeleteAlert(false);
        setToBeDeleted(0);
	}, []);

	// --- START: Handlers for AREA_AI_SETTINGS Tab ---
	const handleAIInputChange = useCallback((e) => {
		const { name, value } = e.target;
		setArea(prevArea => ({
			...prevArea,
			[name]: value
		}));
	}, [setArea]); // Dependency: setArea

	const handleAISwitchCheck = useCallback((currentValue, name) => {
		setArea(prevArea => ({
			...prevArea,
			[name]: !currentValue
		}));
	}, [setArea]); // Dependency: setArea

	const handleActionDragEnd = useCallback((result) => {
		if (!result.destination) return; // dropped outside the list

		const items = Array.from(actionForms);
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);

		setActionForms(items);
		// Update the main area state as well
		setArea(prevArea => ({
			...prevArea,
			actionFlow: JSON.stringify(items) // Store as JSON string
		}));
	}, [actionForms, setActionForms, setArea]); // Dependencies: actionForms, setActionForms, setArea

	const handleExpandActionArea = useCallback(() => {
		setExpandAction(prev => !prev);
	}, [setExpandAction]); // Dependency: setExpandAction

	const handleAddActionForm = useCallback(() => {
		const newId = actionForms.length > 0 ? Math.max(...actionForms.map(f => f.id)) + 1 : 1;
		const newAction = {
			id: newId,
			// Add default fields for a new action form here
			name: `Action ${newId}`,
			type: CHATBOT_ACTION_OPTIONS[0].actionType, // Default type
			value: '',
			// ... other necessary fields
		};
		const updatedForms = [...actionForms, newAction];
		setActionForms(updatedForms);
		setArea(prevArea => ({
			...prevArea,
			actionFlow: JSON.stringify(updatedForms)
		}));
	}, [actionForms, setActionForms, setArea]); // Dependencies: actionForms, setActionForms, setArea

	const handleActionsFlowChange = useCallback((index, updatedForm) => {
		const updatedForms = actionForms.map((form, i) =>
			i === index ? updatedForm : form
		);
		setActionForms(updatedForms);
		setArea(prevArea => ({
			...prevArea,
			actionFlow: JSON.stringify(updatedForms)
		}));
	}, [actionForms, setActionForms, setArea]); // Dependencies: actionForms, setActionForms, setArea

	const handleRemoveActionForm = useCallback((index) => {
		const updatedForms = actionForms.filter((_, i) => i !== index);
		setActionForms(updatedForms);
		setArea(prevArea => ({
			...prevArea,
			actionFlow: JSON.stringify(updatedForms)
		}));
	}, [actionForms, setActionForms, setArea]); // Dependencies: actionForms, setActionForms, setArea

	const handleRemoveSubAction = useCallback((index, parentId) => {
		const updatedForms = actionForms.map((form, i) =>
			form.id === parentId ? { ...form, subActions: form.subActions.filter((_, j) => j !== index) } : form
		);
		setArea(prevArea => ({
			...prevArea,
			actionFlow: JSON.stringify(updatedForms)
		}));
		setActionForms(updatedForms);
	}, [actionForms, setActionForms, setArea]);

	useEffect(() => {
		if (area.actionFlow) {
			try {
				const parsedForms = JSON.parse(area.actionFlow);
				if (JSON.stringify(parsedForms) !== JSON.stringify(actionForms)) {
					setActionForms(parsedForms);
				}
			} catch (e) {
				console.error('Error parsing actionFlow:', e);
			}
		}
	}, [area.actionFlow, actionForms]);

	const handlePersonalitySelectChange = useCallback((value) => {
		const personalityId = parseInt(value, 10) || null; // Ensure it's a number or null
		setArea(prevArea => ({
			...prevArea,
			personality: personalityId,
			// Optionally reset useEmoji if personality is not Casual (id: 1)
			...(personalityId !== 1 && { useEmoji: false })
		}));
	}, [setArea]);

	const handleLibrarySelectChange = useCallback((value) => {
		const libraryId = parseInt(value, 10) || null; // Ensure it's a number or null
		setArea(prevArea => ({
			...prevArea,
			libraryForAI: libraryId
		}));
	}, [setArea]);
	// --- END: Handlers for AREA_AI_SETTINGS Tab ---


	// Render logic starts here
	const conversationBotTabContent = null; // Kept from original, might need review
	const iconTimeStyle = {
		cursor: 'pointer',
		verticalAlign: 'sub'
	};
	const conversationBotTab = (
        <li role="presentation" id="orgTab_5" className="nav-item" data-qa-id="QA_tab_working_bot">
			<a className={activeTab === CONVERSATIONBOTWORKINGHOUR ? "active" : ""} href="#library"
				onClick={() => toggle(CONVERSATIONBOTWORKINGHOUR)}>{I("Working hours for Conversation bot")}
			</a>
		</li>
    );
	const conversationBotBreakTab = (
        <li role="presentation" id="orgTab_13" className="nav-item" data-qa-id="QA_tab_working_bot">
				<a className={activeTab === CONVBOTBREAKHOURS ? "active" : ""} href="#library"
					onClick={() => toggle(CONVBOTBREAKHOURS)}>{I("Working hours break for Conversation bot")}
				</a>
			</li>
    );

	const allSkills = props.skillList;
	const proficiencyList = props.proficiencyList;
	const areaSkills = props.areaSkills;
	const adminActionAlert = props.adminActionAlert;
	const rowEvents = {
		onClick: (e, row) => {
			// Original onClick was empty
		}
	};

    const actionDatas = {
        onEdit: handleEditAreaSkill
        , onDelete: handleDeleteAreaSkill
    };

	const skillCols = [
		{
			dataField: 'id',
			text: 'ID',
			sort: true,
			hidden: true
		},
		{
			dataField: 'name',
			text: I('Skill'),
			sort: true,
		},
		{
			dataField: 'proficiency',
			text: I('Minimum required proficiency'),
			sort: true,
			formatter: (cell, row) => {
				let profName = "";
                // Ensure proficiencyList is available before iterating
				proficiencyList?.forEach((item) => {
					if (item.id === cell) {
						profName = item.name;
					}
				});
				return profName;
			},
		},
		{
			isDummyField: true,
			dataField: 'id',
			text: I('Action'),
			headerClasses: 'center',
			formatter: (cell, row) => {
				return renderSkillActions(cell, row, actionDatas);
			},
		}
	];

	const areaOptTools = useMemo(() => {
		let tools = [];
		if (area?.actionToolsOption?.buttons?.length > 0) {
			tools = area.actionToolsOption.buttons;
		}
		return tools;
	}, [area]);

	let element = null;
	if (props.id > 0 && area) { // Added check for area being populated
		element = <React.Fragment>
				<TabPane tabId={WORKINGHOUR}>
					<WorkingHours
						orgWorkingTimeRules={area.orgWorkingTimeRules}
						orgWorkingTimeExceptions={area.orgWorkingTimeExceptions}
						workingTimeRules={area.workingTimeRules}
						workingTimeExceptions={area.workingTimeExceptions}
						usedFor="area"
						saving={saving}
						saveOrganization={handleSaveArea}
						cancelToOrg={props.onCloseEdit}
						saveWorkingHourExcp={handleWorkingException}
						updateRulesField={"workingTimeRules"}
						updateExceptionsField={"workingTimeExceptions"}
					/>
				</TabPane>
				<TabPane tabId={BREAKHOURS}>
					<BreakHours
						orgWorkingTimeRules={area.orgBreakTimeRules}
						breakTimeRules={area.breakTimeRules}
						usedFor="area"
						saving={saving}
						saveOrganization={handleSaveArea}
						cancelToOrg={props.onCloseEdit}
						saveWorkingHourExcp={handleWorkingException}
						updateRulesField={"areaBreakTimeRules"} // Check if this field name is correct
					/>
				</TabPane>
				<TabPane tabId={CONVERSATIONBOTWORKINGHOUR}>
					<WorkingHours
						orgWorkingTimeRules={area.orgConversationBotWorkingTimeRules}
						orgWorkingTimeExceptions={area.orgConversationBotWorkingTimeExceptions}
						workingTimeRules={area.conversationBotWorkingTimeRules}
						workingTimeExceptions={area.conversationBotWorkingTimeExceptions}
						usedFor="area"
						saving={saving}
						saveOrganization={handleSaveArea}
						cancelToOrg={props.onCloseEdit}
						saveWorkingHourExcp={handleWorkingException}
						updateRulesField={"conversationBotWorkingTimeRules"}
						updateExceptionsField={"conversationBotWorkingTimeExceptions"}
					/>
				</TabPane>
				<TabPane tabId={CONVBOTBREAKHOURS}>
					<BreakHours
						orgWorkingTimeRules={area.conversationBotOrgBreakTimeRules}
						breakTimeRules={area.conversationBotBreakTimeRules}
						usedFor="area"
						saving={saving}
						saveOrganization={handleSaveArea}
						cancelToOrg={props.onCloseEdit}
						saveWorkingHourExcp={handleWorkingException}
						updateRulesField={"conversationBotBreakTimeRules"}
					/>
				</TabPane>
				<TabPane tabId={AREA_AI_SETTINGS}>
					{/* Moved AI Settings Components */}
					<div className="area-form">
						{//only show this option when Agent Assist still using OpenAI
							features["openai-rewrite-answer"] && features["openai-agent-assist-uses-openai"] &&
							<div className="row">
								<div className="col-lg-12">
									<div className="form-group-org">
										<label className="col-sm-12 col-lg-12">{I("Custom AI Instructions")}:</label>
										<div className="col-sm-11 col-lg-11">
											<textarea
												name="customAIInstructions"
												className="form-control input-sm"
												placeholder={I("E.g: Rephrase my text to spellcheck and keep it short tidy.")}
												value={area.customAIInstructions || ""} // Use area state
												onChange={handleAIInputChange} // Use new handler
											/>
										</div>
										<div className="col-lg-1 col-sm-1">
											<Helper helper={I("What would you like AI to know about you to provide better responses ? Use placeholder [ANSWER] to be replaced with answer in errand handling.")} />
										</div>
									</div>
								</div>
								<div className="col-lg-12">
									<div className="form-group-org">
										<label className="col-sm-12 col-lg-12">{I("How AI should respond ?")}</label>
										<div className="col-sm-11 col-lg-11">
											<textarea
												name="customAIResponse"
												className="form-control input-sm"
												placeholder={I("E.g: Write like a customer success manager in a customer service center.")}
												value={area.customAIResponse || ""} // Use area state
												onChange={handleAIInputChange} // Use new handler
											/>
										</div>
										<div className="col-lg-1 col-sm-1">
											<Helper helper={I("How would you like AI to respond? Use placeholder [ANSWER] to be replaced with answer in errand handling.")} />
										</div>
									</div>
								</div>
							</div>
						}
						<Feature tag="machine-learning.auto-answer">
							<div className="row">
								<div className="col-lg-12">
									<div className="form-group-org">
										<label className="col-sm-12 col-lg-12">{I("Enable auto answer")}:</label>
										<div className="col-lg-1">
											<SwitchCheckbox
												active={area.autoAnswer} // Use area state
												buttonClassName={""}
												id={"orgActiveSwitchAI"}
												name={"autoAnswer"}
												type="checkbox"
												onClick={() => { handleAISwitchCheck(area.autoAnswer, "autoAnswer") }} // Use new handler
											/>
										</div>
										<div className="col-lg-1">
											<Helper helper={I("Enable this option to use generative AI to automatic answer errand in this area")} />
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-lg-12 col-sm-12">
									<div className="form-group-org">
										<div className="col-sm-12 col-lg-12">
											<SelectInputRow
												id="libraryForAI"
												name="libraryForAI"
												className="libraryId"
												label={I('Default Knowledge base for AI')}
												option={formatValueToNameObj(area.libraryList, "id", "name")}
												value={area.libraryForAI}
												onSelect={handleLibrarySelectChange}
											/>
										</div>
									</div>
								</div>
							</div>
						</Feature>
						<Feature tag="machine-learning.bot-chat">
							<div className="row">
								<div className="col-lg-12">
									<div className="form-group-org">
										<label className="col-sm-12 col-lg-12">{I("Company brief information")}:</label>
										<div className="col-lg-11">
											<TextInputRow
												id="companyBriefInfo"
												name="companyBriefInfo"
												value={area.companyBriefInfo}
												onChange={handleAIInputChange}
												disabled={false}
												textArea={true}
												rows={3}
												cols={100}
											/>
										</div>
										<div className="col-lg-1">
											<Helper helper={I("Describe the business or the organization in the best way to be used by AI to answer chat in this area")} />
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-lg-6">
									<div className="form-group-org" style={{ marginLeft: '20px' }}>
										<SelectInputRow
											label={I('Personality')}
											id="personality"
											name="personality"
											className="admin-select-area-chat-personality"
											option={CHATBOT_PERSONALITY}
											mandatory={false}
											value={area.personality} // Use area state
											textNoItemSelected={I("Please select")}
											onSelect={handlePersonalitySelectChange} // Use new handler
										/>
									</div>
								</div>
								{
									area.personality == 1 && // Use area state
									<div className="col-lg-6">
										<div className="form-group-org" style={{ paddingTop: '30px' }}>
											<label htmlFor={"admin-chatbot-enable-emoji"} style={{ marginRight: '20px' }}>{I("With emoji")}</label>
											<SwitchCheckbox
												active={area.useEmoji} // Use area state
												buttonClassName={""}
												id={"admin-chatbot-enable-emoji"}
												name={"useEmoji"}
												type="checkbox"
												onClick={() => { handleAISwitchCheck(area.useEmoji, "useEmoji") }} // Use new handler
												//disabled={area.personality != 1} // Use area state
												data-qa-id={"bot-use-emoji"}
											/>
										</div>
									</div>
								}
							</div>
							{
							/*
								Chat predefined buttons, give options for area to display buttons upon started chat with this area
								But have options to display the buttons before the chat session starts
							*/
							<div>
								<div className="row">
									<div className="col-lg-12">
										<div className="form-group-org">
											<label className="col-sm-12 col-lg-12">{I("Enable chat predefined buttons")}:</label>
											<div className="col-lg-1">
												<SwitchCheckbox
													active={area.enableChatTrigger}
													buttonClassName={""}
													id={"admin-chatbot-enable-chat-actions-trigger"}
													name={"enableActionsTrigger"}
													type="checkbox"
													data-qa-id="bot-enable-chat-trigger"
													onClick={() => { handleAISwitchCheck(area.enableChatTrigger, "enableChatTrigger") }}
												/>
											</div>
											<div className="col-lg-1">
												<Helper helper={I("Enable this will show set of buttons upon started chat with this area")} />
											</div>
										</div>
									</div>
									{
									features["chat.enable-new-chat"] &&
										<div className="col-lg-12">
											<div className="form-group-org">
												<label className="col-sm-12 col-lg-12">{I("Show predefined buttons before chat starts")}:</label>
												<div className="col-lg-1">
													<SwitchCheckbox
														active={area.showButtonsBeforeChatStarted}
														buttonClassName={""}
														id={"admin-chatbot-enable-chat-actions-trigger"}
														name={"showButtonsBeforeChatStarted"}
														type="checkbox"
														data-qa-id="bot-show-buttons-before-chat-start"
														onClick={() => { handleAISwitchCheck(area.showButtonsBeforeChatStarted, "showButtonsBeforeChatStarted") }}
													/>
												</div>
												<div className="col-lg-1">
													<Helper helper={I("Enable this will show set of buttons before chat starts")} />
												</div>
												</div>
										</div>
									}
									<div className="col-lg-12">
										<div className="form-group-org">
											{
												<DragDropContext onDragEnd={handleActionDragEnd}> {/* Use new handler */}
													<div id="AreaDragDropKanban" className="dragDrop-context single-drop" style={{ maxHeight: 'max-content' }}>
														<div className={"board__container"}>
															<div className="board__title" title={I("Actions")}>
																{I("Predefined buttons")}
															</div>
															<Droppable droppableId="areaActionBoxes">
																{(provided, snapshot) => (
																	<div
																		className={classNames("board__body", { "isDraggingOver": snapshot.isDraggingOver })}
																		// style={getSubDroppableStyle(snapshot.isDraggingOver)}
																		ref={provided.innerRef}
																		{...provided.droppableProps}
																	>
																		<div className="board__body-inner-wrap">
																			{actionForms.map((form, index) => ( // Use state variable
																				<Draggable key={"areaActionKey-" + index + form.id} draggableId={"areaActionTool-" + form.id + index + 1} index={index}>
																					{(provided, snapshot) => (
																						<div
																							className={classNames("item", { "isDragging": (snapshot.isDragging && !snapshot.isDropAnimating) })}
																							style={getItemStyle(
																								snapshot.isDragging,
																								provided.draggableProps.style
																							)}
																							ref={provided.innerRef}
																							{...provided.dragHandleProps}
																							{...provided.draggableProps}
																						>
																							<ActionFlowForm
																								key={"area-action-" + index}
																								id={index + 1}
																								actions={form}
																								optTools={areaOptTools} //fixme @sue, get this by area
																								onChange={(updatedForm) => handleActionsFlowChange(index, updatedForm)} // Use new handler
																								onRemove={() => handleRemoveActionForm(index)} // Use new handler
																								onRemoveSubAction={() => handleRemoveSubAction(index, form.id)} // Use new handler
																							/>
																						</div>
																					)}
																				</Draggable>
																			))}
																			{
																				actionForms.length === 0 && <div style={{ textAlign: 'center', color: '#6d6d6d', margin: 'auto', width: '100%', padding: '50px 40%' }}>{I("No buttons defined")}</div> // Use state variable
																			}
																			{provided.placeholder}
																		</div>
																	</div>
																)}
															</Droppable>
														</div>
													</div>
													<div style={{ marginTop: '10px' }}>
														<SaveButton onClick={handleAddActionForm} text={I("Add action flow")} title={I(" Add New Action Flow")} /> {/* Use new handler */}
													</div>
												</DragDropContext>
											}
										</div>
									</div>
								</div>
							</div>
						}
						</Feature>
					</div> {/* End wrapper div */}
					<div className="form-group editPageActionButton">
						<div className="row">
							<div className="col-lg-12 textAlignRight">
								<CancelButton onClick={props.onCloseEdit} /> {/* Use prop directly */}
								<SaveButton
									key="btn-save-admin-ai"
									onClick={() => {
										const updatedAreaValues = {
											id: area.id,
											organisationId: area.organisationId,
											areaSettingPresent: true,
											automationSettingsOnly: true,
											customAIInstructions: area.customAIInstructions,
											customAIResponse: area.customAIResponse,
											autoAnswer: area.autoAnswer,
											libraryForAI: area.libraryForAI,
											companyBriefInfo: area.companyBriefInfo,
											systemPromptText: area.systemPromptText,
											instructPromptText: area.instructPromptText,
											personality: area.personality,
											useEmoji: area.useEmoji,
											enableChatTrigger: area.enableChatTrigger,
											showButtonsBeforeChatStarted: area.showButtonsBeforeChatStarted,
											actionFlow: area.actionFlow
										};
										handleSaveArea(AREA_AI_SETTINGS, updatedAreaValues)
									}}
									text={saving ? BTN_TXT_SAVING : BTN_TXT_SAVE}
									disabled={saving}
								/>
							</div>
						</div>
					</div>
				</TabPane>
				<TabPane tabId={AREASKILLS}>
					{ cflag.IsActive("2023-09-29.CEN-1599.skills.admin.page") &&
						<Fragment>
							<form id="skillAdminForn" className="admin-one-form edit-admin-form skills-admin-form">
								<div className="row" style={{ width: '100%' }}>
									<div className="col-11 col-md-11">
										<FormInputWithLabelRow
											label={I('Required area skill')}
											inlineLabel={false}
											helperTxt={I('Manage area skills')}
										>
										</FormInputWithLabelRow>
									</div>
									<div className="col-1 col-md-1" style={{ display: 'flex', gap: '8px' }}>
										<div style={AddAgentBtnStyle} onClick={handleOpenSelectSkillModal}> {/* Use direct handler */}
											<i style={{ color: '#6D6D6D' }} className="icon-add"></i>
										</div>
									</div>
								</div>
								<ListContentWrapper className={"v5-table-style"}>
									<BootstrapTable
										keyField="id"
										data={areaSkills || []} // Ensure areaSkills is an array
										noDataIndication={I("No data to display")}
										columns={L(skillCols)}
										bordered={false}
										condensed={false}
										defaultSorted={ [{
											dataField: 'name',
											order: 'asc'
										}]}
										pagination={paginationFactory(SkillTableOptions)}
										rowEvents={ rowEvents }
										hover
									/>
								</ListContentWrapper>
							</form>
						</Fragment>
					}
					{
						cflag.IsActive("2023-09-29.CEN-1599.skills.admin.page") && openSkillModal && // Use state variable
						<SkillUpdateModal
							show={openSkillModal} // Use state variable
							isNew={activeAreaSkill ? false : true} // Use state variable
							selectAgentMode={false}
							selectSkillMode={true}
							selectedSkill={activeSkillModal} // Use state variable
							proficiencyList={proficiencyList}
							skillList={skillList} // Use prop directly
							onClose={handleCloseSkillModal} // Use direct handler
							onSave={handleSaveSkill} // Use direct handler
							onDelete={handleDeleteAreaSkill} // Use direct handler
						/>
					}
					{	cflag.IsActive("2023-09-29.CEN-1599.skills.admin.page") &&
						<DeletePopup
							title={I("Are you sure you want to remove this skill from area?")}
							icon={'icon-caution'}
							show={showDeleteAlert} // Use state variable
							onDelete={handleConfirmDelete} // Use direct handler
							onClose={handleCancelDelete} // Use direct handler
						/>
					}
				</TabPane>
				<TabPane tabId={OPENEXTERNAL}>
					{area.organisationId &&<OpenExternalV5
						id={id} // From props
						orgId={area.organisationId} // From state
						externalSystemRules={area.externalSystemRules} // From state
						openExternalSystemRulesId={area.openExternalSystemRulesId} // From state
						saveOrganization={handleSaveArea} // From useCallback
						saveAreaExternal={handleSaveAreaExternal} // From useCallback
						usedFor="area"
						saving={saving} // From state
						cancelToOrg={onCloseEdit} // From props
						keepOrgOpenExt={area.keepOrgOpenExt} // From state
					/>}
				</TabPane>
				<TabPane tabId={BRIGHT}>
				{area.brightSettings &&<BrightSettingV5
						id={id} // From props
						brightSettings={area.brightSettings} // From state
						saveOrganization={handleSaveArea} // From useCallback
						usedFor="area"
						saving={saving} // From state
						cancelToOrg={onCloseEdit} // From props
					/>}
				</TabPane>
				<TabPane tabId={ARTIFICIALSOL}>
					{area.artificialSettings && <ArtificialSettingV5
						id={id} // From props
						artificialSettings={area.artificialSettings} // From state
						saveOrganization={handleSaveArea} // From useCallback
						usedFor="area"
						saving={saving} // From state
						cancelToOrg={onCloseEdit} // From props
					/>}
				</TabPane>
				<TabPane tabId={AREAREPLACEMENT}>
					<AreaTableEdit
						type={AREAREPLACEMENT}
						id={id} // From props
						saveOrg={handleSaveArea} // From useCallback
						cancelToOrg={onCloseEdit} // From props
					/>
				</TabPane>
				<TabPane tabId={AREAAUTOFORWARD}>
					<AreaTableEdit
						type={AREAAUTOFORWARD}
						id={id} // From props
						saveOrg={handleSaveArea} // From useCallback
						cancelToOrg={onCloseEdit} // From props
					/>
				</TabPane>
				<TabPane tabId={AREASMS}>
					<AreaTableEdit
						type={AREASMS}
						id={id} // From props
						saveOrg={handleSaveArea} // From useCallback
						cancelToOrg={onCloseEdit} // From props
					/>
				</TabPane>
				<TabPane tabId={AREAFORWARDEXTERNAL}>
					<AreaTableEdit
						type={AREAFORWARDEXTERNAL}
						id={id} // From props
						saveOrg={handleSaveArea} // From useCallback
						cancelToOrg={onCloseEdit} // From props
					/>
				</TabPane>
			</React.Fragment>
	} else {
		element = null;
	}

	return (
		<div className="organization-edit" id="area-edit-v5">
			<div className="panel panel-default">
				<div className="row">
					<div className="col-lg-8 panel-heading">
						<h3>
							<span className='edit-header-icon'>
								<i
									className='icon-edit'
								/>
							</span>
							{title}
						</h3>
					</div>
					<div className='col-lg-4' style={{ textAlign: 'right', right: 10 }}>
					{title === I("Edit area") && (
                        <span
                            style={iconTimeStyle}
                            onClick={handleCopyData}
                            title={copyHoverText}
                        >
                            <i style={{ color: copyIconColor, marginRight: 10}} className="icon-copy"></i>
                        </span>
                    )}

                    {title === I("Add new area") && copyData && copyData.data && (
                        <span
                            style={iconTimeStyle}
                            onClick={handlePasteData}
                            title={pasteHoverText}
                        >
                            <i style={{ color: pasteIconColor, marginRight: 10}} className="icon-paste"></i>
                        </span>
                    )}
						<span style={iconTimeStyle} onClick={props.onCloseEdit}>
							<i className='icon-times'></i>
						</span>
					</div>
					<AlertWrapper id={"OrgAreaAlert"} hidden={adminActionAlert.show ? false : true} onDismiss={props.onDismissAlert}>
						<DismissableAlert show={adminActionAlert.show ? true : false}
							role={adminActionAlert.type === "error" ? "danger" : "success"}
							text={adminActionAlert.msg}
							icon={adminActionAlert.type === "error" ? "icon-caution" : "icon-new-tick-single"}
							onDismiss={props.onDismissAlert}
						/>
					</AlertWrapper>
				</div>
				<div className="panel-body">
					{tabPage == 1 &&
						<ul className="nav org-nav-tabs col-md-12">
							<li role="presentation" id="orgTab_0" className="nav-item" data-qa-id="QA_org">
								<a className={activeTab === AREA ? "active" : ""} href="#" // Changed from ORG to AREA based on context
									onClick={() => toggle(AREA)}>{I('Organization')}
								</a>
							</li>
							<li role="presentation" id="orgTab_1" className="nav-item" data-qa-id="QA_org_working">
								<a className={activeTab === WORKINGHOUR ? "active" : ""} href="#"
									onClick={() => toggle(WORKINGHOUR)}>{I('Working hours')}
								</a>
							</li>
							<li role="presentation" id="orgTab_12" className="nav-item" data-qa-id="QA_org_working">
								<a className={activeTab === BREAKHOURS ? "active" : ""} href="#"
									onClick={() => toggle(BREAKHOURS)}>{I('Working hours break')}
								</a>
							</li>
							<Feature tag="open-external-system">
								<li role="presentation" id="orgTab_2" className="nav-item" data-qa-id="QA_org_external">
									<a className={activeTab === OPENEXTERNAL ? "active" : ""} href="#"
										onClick={() => toggle(OPENEXTERNAL)}>{I('Open External System settings')}
									</a>
								</li>
							</Feature>
							<Feature tag="bright-integration">
								<li role="presentation" id="orgTab_3" className="nav-item" data-qa-id="QA_org_bright">
									<a className={activeTab === BRIGHT ? "active" : ""} href="#"
										onClick={() => toggle(BRIGHT)}>{I('Bright Settings')}
									</a>
								</li>
							</Feature>
							<Feature tag="artificial-solutions">
								<li role="presentation" id="orgTab_4" className="nav-item" data-qa-id="QA_org_artificial">
									<a className={activeTab === ARTIFICIALSOL ? "active" : ""} href="#"
										onClick={() => toggle(ARTIFICIALSOL)}>{I('Artificial Solutions Settings')}
									</a>
								</li>
							</Feature>
							{conversationBotTab}
							{conversationBotBreakTab}
							{
								(features["machine-learning.auto-answer"] || features["machine-learning.bot-chat"] || features["openai-agent-assist-uses-openai"]) &&
								<Fragment>
									<li role="presentation" id={"orgTab_" + AREA_AI_SETTINGS} className="nav-item" data-qa-id="QA_org_working">
										<a className={activeTab === AREA_AI_SETTINGS ? "active" : ""} href="#"
											onClick={() => toggle(AREA_AI_SETTINGS)}>{I('Automation')}
										</a>
									</li>
								</Fragment>
							}
							{
								cflag.IsActive("2023-09-29.CEN-1599.skills.admin.page") &&
								<li role="presentation" id={"orgTab_" + AREASKILLS} className='nav-item' data-qa-id="QA_org_skills">
									<a className={activeTab === AREASKILLS ? "active" : ""} href="#"
										onClick={() => toggle(AREASKILLS)}>{I('Skills requirements')}
									</a>
								</li>
							}
							<li role="presentation" id="orgTab_6" className="nav-item nav-page-toggle" data-qa-id="QA_org_working" style={{}}>
								<a className="arrow-right" href="#"
									onClick={() => handleChangeTab()}> {/* Pass null or 2 as argument */} 
									<i className="icon-chevron-right" />
								</a>
							</li>

						</ul>}
					{tabPage == 2 &&
						<ul className="nav org-nav-tabs col-md-12">
							<li role="presentation" id="orgTab_7" className="nav-item" data-qa-id="QA_org_working">
								<a className={activeTab === AREAREPLACEMENT ? "active" : ""} href="#"
									onClick={() => toggle(AREAREPLACEMENT)}>{I('Replacement')}
								</a>
							</li>
							<li role="presentation" id="orgTab_8" className="nav-item" data-qa-id="QA_org_working">
								<a className={activeTab === AREAAUTOFORWARD ? "active" : ""} href="#"
									onClick={() => toggle(AREAAUTOFORWARD)}>{I('Automatic forward to external')}
								</a>
							</li>
							<li role="presentation" id="orgTab_9" className="nav-item" data-qa-id="QA_org_working">
								<a className={activeTab === AREASMS ? "active" : ""} href="#"
									onClick={() => toggle(AREASMS)}>{"SMS"}
								</a>
							</li>
							<li role="presentation" id="orgTab_10" className="nav-item" data-qa-id="QA_org_working">
								<a className={activeTab === AREAFORWARDEXTERNAL ? "active" : ""} href="#"
									onClick={() => toggle(AREAFORWARDEXTERNAL)}>{I('External Forward Addresses')}
								</a>
							</li>
							<li role="presentation" id="orgTab_11" className="nav-item nav-page-toggle" data-qa-id="QA_org_working" style={{}}>
								<a className="arrow-left" href="#"
									onClick={() => handleChangeTab()}> {/* Pass null or 1 as argument */} 
									<i className="icon-chevron-left" />
								</a>
							</li>

						</ul>}
					<div className="row">
						<div className="col-lg-12 dot-row">
							<span onClick={() => handleChangeTab(2)} className={tabPage === 1 ? "dot active" : "dot"}></span>
							<span onClick={() => handleChangeTab(1)} className={tabPage === 2 ? "dot active" : "dot"}></span>
						</div>
					</div>
					<TabContent activeTab={activeTab}>
						<TabPane tabId={AREA}>
							<AreaForm
								area={area} // Pass state directly
								saveOrganization={handleSaveArea}
								languages={area.languages} // Assuming area state holds this
								archiveImages={area.areaFileArchive} // Assuming area state holds this
								saving={saving} // Pass state directly
								cancel={props.onCloseEdit}
                                features={features} // Pass features if needed by AreaForm
							/>
						</TabPane>
						{element}
					</TabContent>
				</div>
			</div>
		</div>
	);
}

const Label = ({ text }) => <label className="col-sm-12 col-md-2">{text}:</label>;

function boolToZeroOne(bool) {
	if (bool) {
		return 1;
	}
	return 0;
}

function zeroOneToBool(zeroOrOne) {
	if (typeof zeroOrOne === "string") {
		zeroOrOne = parseInt(zeroOrOne, 10);
	}
	return !!zeroOrOne;
}

const PCI = ({ onSelect, options, value }) => {
	if (!value) {
		return null;
	}
	return (
		<div className="row">
			<div className="col-lg-6">
				<div className="form-group-org">
					<div className="col-sm-12 col-lg-12">
						<SelectInputRow
							id="PCI"
							name="PCI"
							className="PCI"
							label={I('PCI - auto delete attachments')}
							option={formatValueToNameObj(options, "id", "value")}
							value={boolToZeroOne(value.enabled)}
							onSelect={onSelect}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

const Input = ({ className, name, onChange, value }) => (
	<input
		name={name}
		className={className}
		type="text"
		value={value}
		onChange={onChange}
	/>
);

const PCIHoursKeepAttachment = React.memo(({ onChange, value }) => {
	if (!value || !value.enabled) {
		return null;
	}
	return (
		<div className="row">
			<div className="col-lg-6">
				<div className="form-group-org">
					<label className="col-lg-12">{I("Hours to keep attachments")} :</label>
					<div className="col-lg-12">
						<Input
							className="form-control input-sm"
							type="text"
							value={value.hoursKeepAttachments}
							onChange={onChange}
						/>
					</div>
				</div>
			</div>
		</div>
	);
});

const TextInput = ({ className, name, onChange, value }) => (
	<div className={className}>
		<input
			name={name}
			className="form-control input-sm"
			type="text"
			value={value}
			onChange={onChange}
		/>
	</div>
);

const ExtFwdNumber = ({ onChange, value }) => (
	<div className="form-group-org">
		<label className="col-lg-12">{I("Number for external automatic forwarding")}:</label>
		<TextInput
			className="col-lg-12"
			name="extFwdNumber"
			onChange={onChange}
			value={value}
		/>
	</div>
);

class AreaForm extends PureComponent {
	constructor(props) {
		super(props);
		this.selectedEmailServers = [];
		this.newServerEmailId = -1;
		this.selectedAvailableGroups = "";
		
		// Initialize with default state for React 18 compatibility
		const defaultExpireTime = {
			days: 0,
			hours: 0,
			mins: 0
		};
		
		this.state = {
			// Loading states
			isUploading: false,
			isProcessing: false,
			uploadProgress: "",
			
			// Arrays
			languages: [],
			archiveImages: [],
			salutationList: [],
			signatureList: [],
			emailAddressList: [],
			organisationList: [],
			routingGroups: [],
			areaList: [],
			ownEmails: [],
			
			// Numbers
			organisationId: 0,
			id: 0,
			timeZoneId: 0,
			daysToKeepErrand: 0,
			defaultSalutation: 0,
			defaultSignature: 0,
			externalPriority: 0,
			maxAllowedQueuedChatSessions: 0,
			libraryId: 0,
			libraryForAI: 0,
			outboundPhoneId: 0,
			solidusPriorityServiceGroupId: 0,
			solidusServiceGroupId: 0,
			dueDateAreaId: 0,
			anonymizeDay: 0,
			feedbackSendOutDelay: 0,
			blackoutPeriodAfterSurvey: 0,
			
			// Strings
			name: "",
			replyToEmailAddress: "",
			newServerEmail: "",
			replyToName: "",
			chatAreaUrl: "",
			chatExternalId: "",
			defaultBanner: "",
			defaultSubjectPrefix: "",
			description: "",
			doQuickSearch: "",
			expectedDoneDateNote: "",
			externalChatId: "",
			externalExpertFrom: "",
			externalId: "",
			htmlBanner: "",
			htmlexpectedDoneDateNote: "",
			noteToExternalExperts: "",
			extFwdNumber: "",
			preFilledExternalExpert: "",
			proActiveChat: "",
			quickSearchCircularId: "",
			receiptEmailAddress: "",
			sipOutgoingDialPlanId: "",
			sipQueueId: "",
			sipExtFwdNumber: "",
			predefinedChatMessage: "",
			solidusServiceGroupIdsForChat: "",
			prefixSubject: "",
			uploadFileName: "",
			uploadLocalFileName: "",
			customAIInstructions: "",
			customAIResponse: "",
			systemPromptText: "",
			instructPromptText: "",
			excludeAnonymize: "",
			companyBriefInfo: "",
			note: "",
			
			// Booleans
			hasChat: false,
			hasVoice: false,
			disableAdminFbPostComments: true,
			hasSevenDaysWhatsapp: false,
			enabledPredefinedChatMessage: false,
			hasPostpone: false,
			removeErrandFromArea: false,
			externalExpertsByEmail: false,
			onlyAdminCanChangeSalutation: false,
			onlyAdminCanChangeSignature: false,
			showNameError: false,
			showReplyToError: false,
			anonymizeContact: false,
			showArea: false,
			autoAnswer: false,
			
			// Complex objects
			errandExpireTime: { ...defaultExpireTime },
			collabErrandExpireTime: { ...defaultExpireTime },
			partialExpireTime: { ...defaultExpireTime },
			partialReplyWarningInterval: { ...defaultExpireTime },
			generalWarningExpireTime: { ...defaultExpireTime },
			partialAlertTime: { ...defaultExpireTime },
			generalExpireTime: { ...defaultExpireTime },
			
			// Other objects
			mailAccountRules: {
				receiptActiveFrom: "00:00",
				receiptActiveTo: "23:59",
				receiptByTimeInterval: false,
				receiptHtmlBody: "",
				receiptSubject: "",
				receiptTextBody: "",
				receiptOutOfActiveHourSelected: 0,
				receiptHtmlBodyOutOfActiveHour: "",
				receiptSubjectOutOfActiveHour: "",
				receiptTextBodyOutOfActiveHour: "",
				reoccuringReceipt: 0,
				reoccuringReceiptBody: "",
				reoccuringReceiptHtmlBody: "",
				reoccuringReceiptInterval: 1,
				reoccuringReceiptSubject: "",
				selected: 0,
				requireReceipt: false
			},
			
			dueDate: {
				dueDateSelected: 0,
				hasDoneDateNotification: false,
				doneDateAddress: "",
				expectedDoneDateNote: ""
			},
			
			agentGroupListing: {},
			agentGroupSelected: {},
		}
	}
	
	// Add after getMemoizedValue method
	getMemoizedValue(key, calculateFn) {
		// Simple memoization implementation for class components 
		if (!this._memoizedValues) {
			this._memoizedValues = new Map();
		}
		
		if (!this._memoizedValues.has(key)) {
			this._memoizedValues.set(key, calculateFn());
		}
		
		return this._memoizedValues.get(key);
	}
	
	// Add memoized event handler method
	getMemoizedHandler(key, handler) {
		// Create a memoized version of event handlers (similar to useCallback)
		return this.getMemoizedValue(`handler_${key}`, () => handler);
	}
	
	// Add error rendering to the top of render method
	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI
		return { 
			hasError: true, 
			errorMessage: error.toString() 
		};
	}
	
	handlePCIAutoDeleteAttachments = (v, n) => {
		const pci = {
				enabled: zeroOneToBool(v)
				, hoursKeepAttachments: this.state.pci.hoursKeepAttachments
			}
			;
		this.setState({ pci });
	}
	handleChangePCIHoursKeepAttachment = (value, e) => {
		this.setState({
			pci: {
				enabled: this.state.pci.enabled
				, hoursKeepAttachments: value
			}
		});
	}
	handleCkeditorChange = (event) => {
		let name = event.editor.name;
		this.setState({ [name]: event.editor.getData() });
	}
	
	static getDerivedStateFromProps(props, state) {
		if(JSON.stringify(props.area) === "{}" || !props.area) {
				return null;
		}
		if (props.area !== state.area) {
			const area = props.area;
			const rules = area.mailAccountRules || {};
			return {	
				languages: area.languages,
				archiveImages: area.areaFileArchive,
				salutationList: area.salutationList,
				signatureList: area.signatureList,
				organisationId: area.organisationId,
				organisationList: area.organisationList,
				name: area.name,
				id: area.id,
				replyToEmailAddress: area.replyToEmailAddress,
				replyToName: area.replyToName,
				timeZoneId: area.timeZoneId,
				chatAreaUrl: area.chatAreaUrl,
				chatExternalId: area.chatExternalId,
				daysToKeepErrand: area.daysToKeepErrand,
				defaultBanner: area.defaultBanner,
				defaultSalutation: area.defaultSalutation,
				defaultSignature: area.defaultSignature,
				defaultSubjectPrefix: area.defaultSubjectPrefix,
				description: area.description,
				doQuickSearch: area.doQuickSearch,
				emailAddressList: area.emailAddressList,
				expectedDoneDateNote: area.expectedDoneDateNote,
				externalChatId: area.externalChatId,
				externalExpertFrom: area.externalExpertFrom,
				externalExpertsByEmail: area.externalExpertsByEmail,
				externalId: area.externalId,
				externalPriority: area.externalPriority,
				hasChat: area.hasChat,
				hasVoice: area.hasVoice,
				disableAdminFbPostComments: area.disableAdminFbPostComments,
				hasSevenDaysWhatsapp: area.hasSevenDaysWhatsapp,
				sipOutgoingDialPlanId: area.sipOutgoingDialPlanId,
				sipQueueId: area.sipQueueId,
				sipExtFwdNumber: area.sipExtFwdNumber,
				enabledPredefinedChatMessage: area.enabledPredefinedChatMessage,
				predefinedChatMessage: area.predefinedChatMessage,
				hasPostpone: area.hasPostpone,
				htmlBanner: area.htmlBanner,
				htmlexpectedDoneDateNote: area.htmlexpectedDoneDateNote,
				libraryId: area.libraryId,
				libraryForAI: area.libraryForAI,
				libraryList: area.libraryList,
				maxAllowedQueuedChatSessions: area.maxAllowedQueuedChatSessions,
				noteToExternalExperts: area.noteToExternalExperts,
				ownEmails: area.ownEmails,
				preFilledExternalExpert: area.preFilledExternalExpert,
				proActiveChat: area.proActiveChat,
				quickSearchCircularId: area.quickSearchCircularId,
				receiptEmailAddress: area.receiptEmailAddress,
				removeErrandFromArea: area.removeErrandFromArea,
				routingGroups: area.routingGroups,
				areaList: area.areaList,
				dueDateAreaId: parseInt(area.dueDateAreaId),
				solidusPriorityServiceGroupId: area.solidusPriorityServiceGroupId,
				solidusServiceGroupId: area.solidusServiceGroupId,
				solidusServiceGroupIdsForChat: area.solidusServiceGroupIdsForChat,
				onlyAdminCanChangeSalutation: area.onlyAdminCanChangeSalutation,
				onlyAdminCanChangeSignature: area.onlyAdminCanChangeSignature,
				agentGroupListing: area.agentGroupListing,
				agentGroupSelected: area.agentGroupSelected,
				prefixSubject: area.prefixSubject,
				mailAccountRules: {
					//...prevState.mailAccountRules,
					receiptActiveFrom: rules ? rules.receiptActiveFrom : "",
					receiptActiveTo: rules ? rules.receiptActiveTo : "",
					receiptByTimeInterval: area.receiptByTimeInterval,
					receiptHtmlBody: rules ? rules.receiptHtmlBody: "",
					receiptSubject: rules ? rules.receiptSubject: "",
					receiptTextBody: rules ? rules.receiptTextBody: "",
					receiptOutOfActiveHourSelected: rules ? rules.receiptOutOfActiveHourSelected: "",
					receiptHtmlBodyOutOfActiveHour: rules ? rules.receiptHtmlBodyOutOfActiveHour: "",
					receiptSubjectOutOfActiveHour: rules ? rules.receiptSubjectOutOfActiveHour: "",
					receiptTextBodyOutOfActiveHour: rules ? rules.receiptTextBodyOutOfActiveHour: "",
					reoccuringReceipt: rules ? rules.reoccuringReceipt: "",
					reoccuringReceiptBody: rules ? rules.reoccuringReceiptBody: "",
					reoccuringReceiptHtmlBody: rules ? rules.reoccuringReceiptHtmlBody: "",
					reoccuringReceiptInterval: rules ? rules.reoccuringReceiptInterval: "",
					reoccuringReceiptSubject: rules ? rules.reoccuringReceiptSubject: "",
					selected: rules ? rules.selected : "",
					requireReceipt: rules ? rules.requireReceipt: ""
				},
				outboundPhoneId: area.outbound ? area.outbound.outboundPhoneId : 0,
				extFwdNumber: area.extFwdNumber,
				dueDate: {
					//...prevState.dueDate,
					dueDateSelected: area && area.dueDate ? area.dueDate.dueDateSelected : "",
					hasDoneDateNotification: area && area.dueDate ?area.dueDate.hasDoneDateNotification: "",
					doneDateAddress: area && area.dueDate ? area.dueDate.doneDateAddress: "",
					expectedDoneDateNote: area && area.dueDate ? area.dueDate.expectedDoneDateNote : ""
				},
				partialAlertTime: {
					//...prevState.partialAlertTime,
					days: area && area.partialAlertTime ? area.partialAlertTime.days: "",
					hours: area && area.partialAlertTime ? area.partialAlertTime.hours: "",
					mins: area && area.partialAlertTime ? area.partialAlertTime.mins: "",
				},
				partialExpireTime: {
					//...prevState.partialExpireTime,
					days: area && area.partialExpireTime ? area.partialExpireTime.days: "",
					hours: area && area.partialExpireTime ? area.partialExpireTime.hours: "",
					mins: area && area.partialExpireTime ? area.partialExpireTime.mins: "",
				},
				partialReplyWarningInterval: {
					//...prevState.partialReplyWarningInterval,
					days: area && area.partialReplyWarningInterval ? area.partialReplyWarningInterval.days: "",
					hours: area && area.partialReplyWarningInterval ? area.partialReplyWarningInterval.hours: "",
					mins: area && area.partialReplyWarningInterval ? area.partialReplyWarningInterval.mins: "",
				},
				errandExpireTime: {
					//...prevState.errandExpireTime,
					days: area && area.errandExpireTime ? area.errandExpireTime.days: "",
					hours: area && area.errandExpireTime ? area.errandExpireTime.hours: "",
					mins: area && area.errandExpireTime ? area.errandExpireTime.mins:"",
				},
				collabErrandExpireTime: {
					//...prevState.collabErrandExpireTime,
					days: area && area.collabErrandExpireTime ? area.collabErrandExpireTime.days: "",
					hours: area && area.collabErrandExpireTime ? area.collabErrandExpireTime.hours: "",
					mins: area && area.collabErrandExpireTime ? area.collabErrandExpireTime.mins:"",
				},
				generalExpireTime: {
					//...prevState.generalExpireTime,
					days: area && area.generalExpireTime ? area.generalExpireTime.days: "",
					hours: area && area.generalExpireTime ? area.generalExpireTime.hours: "",
					mins: area && area.generalExpireTime ? area.generalExpireTime.mins: "",
				},
				generalWarningExpireTime: {
					//...prevState.generalWarningExpireTime,
					days: area && area.generalWarningExpireTime ? area.generalWarningExpireTime.days: "",
					hours: area && area.generalWarningExpireTime ? area.generalWarningExpireTime.hours: "",
					mins: area && area.generalWarningExpireTime ? area.generalWarningExpireTime.mins: "",
				},
				anonymizeDay: area.anonymizeDay,
				anonymizeContact: area.anonymizeContact,
				excludeAnonymize: area.excludeAnonymize,
				pci: area.pci,
				feedbackSendOutDelay: area.feedbackSendOutDelay,
				blackoutPeriodAfterSurvey: area.blackoutPeriodAfterSurvey,
				area: props.area,
				customAIInstructions: area.customAIInstructions,
				customAIResponse: area.customAIResponse,
				autoAnswer: area.autoAnswer,
				systemPromptText: area.systemPromptText,
				instructPromptText: area.instructPromptText,
				companyBriefInfo: area.companyBriefInfo,
				note: area.note,
			};
		}
		return null;
	}
	
	handleAddIntoList = (src, des, selectedIDs) => {
		var newList = des.slice();
		selectedIDs.split(",").map(function (id, i) {
			id = parseInt(id);
			src.map(function (keys, index) {
				if (id == keys.id) {
					newList.push(keys);
				}
			});
		});
		return newList;
	}
	handleRemoveFromList = (src, selectedIDs) => {
		var newList = src.slice();
		selectedIDs.split(",").map(function (id, i) {
			id = parseInt(id);
			newList.map(function (keys, index) {
				if (id == keys.id) {
					newList.splice(index, 1);
				}
			});
		});
		return newList;
	}
	handleAddGroups = () => {
		var members = this.handleAddIntoList(this.state.agentGroupListing, this.state.agentGroupSelected, this.selectedAvailableGroups);
		var available = this.handleRemoveFromList(this.state.agentGroupListing, this.selectedAvailableGroups);
		this.selectedAddedMembers = this.selectedAddedMembers + "," + this.selectedAvailableGroups;
		this.selectedAvailableGroups = "";
		this.setState({
			agentGroupListing: available,
			agentGroupSelected: members,
		});
	}
	handleRemoveGroups = () => {
		var available = this.handleAddIntoList(this.state.agentGroupSelected, this.state.agentGroupListing, this.selectedAddedMembers);
		var members = this.handleRemoveFromList(this.state.agentGroupSelected, this.selectedAddedMembers);
		this.selectedAvailableGroups = this.selectedAvailableGroups + "," + this.selectedAddedMembers;
		this.selectedAddedMembers = "";
		this.setState({
			agentGroupListing: available,
			agentGroupSelected: members,
		});
	}
	onSelectAvailable = (id) => {
		this.selectedAvailableGroups = id;
	}
	onSelectGroup = (id) => {
		this.selectedAddedMembers = id;
	}
	expireTimesToJson = () => {
		let expireTimeMap = {}
		expireTimeMap.errandExpireTime = this.state.errandExpireTime;
		expireTimeMap.collabErrandExpireTime = this.state.collabErrandExpireTime;
		expireTimeMap.partialExpireTime = this.state.partialExpireTime;
		expireTimeMap.partialReplyWarningInterval =
			this.state.partialReplyWarningInterval;
		expireTimeMap.generalWarningExpireTime =
			this.state.generalWarningExpireTime;
		expireTimeMap.partialAlertTime = this.state.partialAlertTime;
		expireTimeMap.generalExpireTime = this.state.generalExpireTime;

		return JSON.stringify(expireTimeMap)
	}
	toJson = () => {
		let s = JSON.parse(JSON.stringify(this.state));
		if (typeof s.pci !== "undefined") {
			s.pci = JSON.stringify(this.state.pci);
		}
		s.agentGroupMap = JSON.stringify(this.state.agentGroupSelected);
		s.emailAddressMap = JSON.stringify(this.state.emailAddressList);
		s.dueDateMap = JSON.stringify(this.state.dueDate);
		s.expireTimeMap = this.expireTimesToJson();
		s.mailAccountRulesMap = JSON.stringify(this.state.mailAccountRules);
		delete s.agentGroupSelected;
		delete s.agentGroupListing;
		delete s.emailAddressList;
		delete s.dueDate;
		delete s.ownEmails;
		delete s.libraryList;
		delete s.organisationList;
		delete s.signatureList;
		delete s.archiveImages;
		delete s.languages;
		delete s.errandExpireTime;
		delete s.collabErrandExpireTime;
		delete s.partialExpireTime;
		delete s.partialReplyWarningInterval;
		delete s.generalWarningExpireTime;
		delete s.partialAlertTime;
		delete s.generalExpireTime;
		delete s.mailAccountRules;
		delete s.salutationList;
		delete s.areaList;
		return s
	}
	saveArea = (event) => {
		// if (typeof this.state.uploadFileName == 'undefined' || this.state.uploadFileName == "") {
		// 	if (this.state.name == "" || this.state.name.trim().length == 0) {
		// 		this.setState({ showNameError: true });
		// 		return;
		// 	}
		// 	if (this.state.replyToEmailAddress == ""
		// 		|| this.state.replyToEmailAddress.trim().length == 0) {
		// 		this.setState({ showReplyToError: true });
		// 		return;
		// 	}
		// }
		let s = this.toJson();
		s.areaSettingPresent = true;
		this.props.saveOrganization(AREA, s);
	}
	handleExpireTimeChange = (event) => {
		const target = event.target;
		const value = target.value;
		const name = target.name.split('_')[0];
		const expireType = target.name.split('_')[1];
		let val = 0;
		if (!isNaN(value)) {
			val = Number(value);
		}
		this.setState(prevState => ({
			[name]: {
				...prevState[name],
				[expireType]: val
			}
		}));
	}
	handleSubInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name.split('_')[0];
		const expireType = target.name.split('_')[1];
		this.setState(prevState => ({
			[name]: {
				...prevState[name],
				[expireType]: value
			}
		}), () => {
			//console.log('', this.state.mailAccountRules.selected);
		});
	}
	handleSubInputChangeInt = (event) => {
		const target = event.target;
		const value = target.value;
		const name = target.name.split('_')[0];
		const expireType = target.name.split('_')[1];
		if (isNaN(value) == true) {
			console.info("value for " + target.name + "is not a number");
			return;
		}
		let newVal = parseInt(value);
		this.setState(prevState => ({
			[name]: {
				...prevState[name],
				[expireType]: newVal
			}
		}));
	}
	handleChangeSubData = (a, b) => {
		const value = a;
		const name = b.split('_')[0];
		const expireType = b.split('_')[1];
		if (isNaN(value) == true) {
			console.info("value for " + name + "is not a number");
			return;
		}
		let newVal = parseInt(value);
		this.setState(prevState => ({
			[name]: {
				...prevState[name],
				[expireType]: newVal
			}
		}));
	}
	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		
		this.setState(prevState => {
			// Update error states conditionally
			let updatedState = { [name]: value };
			
			// Only update error states if relevant fields change
			if (name === "name") {
				updatedState.showNameError = false;
			}
			
			if (name === "replyToEmailAddress") {
				updatedState.showReplyToError = false;
			}
			
			return updatedState;
		});
	}
	handleSwitchBoxCheck = (checked, state) => {
		const name = state;
		const value = !checked;
		this.setState(prevState => ({
			[name]: value
		}));
	}
	handleSubSwitchBoxCheck = (checked, state) => {
		const name = state.split('_')[0];
		const expireType = state.split('_')[1];
		const value = !checked;
		this.setState(prevState => ({
			[name]: {
				...prevState[name],
				[expireType]: value
			}
		}));
	}
	handleSubCkeditorChange = (event) => {
		const value = event.editor.getData()
		const name = event.editor.name.split('_')[0];
		const field = event.editor.name.split('_')[1];
		this.setState(prevState => ({
			[name]: {
				...prevState[name],
				[field]: value
			}
		}));
	}
	handleReceiptActiveFrom = (value) => {
		this.setState(prevState => ({
			mailAccountRules: {
				...prevState.mailAccountRules,
				receiptActiveFrom: value
			}
		}));
	}
	handleReceiptActiveTo = (value) => {
		this.setState(prevState => ({
			mailAccountRules: {
				...prevState.mailAccountRules,
				receiptActiveTo: value
			}
		}));
	}
	handleEndChange = (event) => {

	}
	handleKeyDown = (event) => {

	}
	onSelectEmailServer = (value) => {
		this.selectedEmailServers = value;
	}
	sortServerEmail = (a, b) => {
		if (a.order < b.order) {
			return -1
		} else if (a.order > b.order) {
			return 1
		} else {
			return 0
		}
	}
	reOrder = (oldList) => {
		for (var i = 0; i < oldList.length; i++) {
			oldList[i].order = i + 1;
		}
		return oldList;
	}
	handleAddServerEmail = (event) => {
		var newList = this.state.emailAddressList;
		for (var i = 0; i < newList.length; i++) {
			if (newList[i].name == this.state.newServerEmail) {
				this.setState({
					newServerEmail: ""
				});
				return;
			}
		}
		var newEntry = {
			'id': this.newServerEmailId,
			'name': this.state.newServerEmail,
			'order': newList.length + 1
		};
		this.newServerEmailId--;
		if (this.state.newServerEmail.length > 0) {
			if (newList == null) {
				newList = [];
			}
			newList.push(newEntry);
			this.setState({
				emailAddressList: newList,
				newServerEmail: ""
			});
			this.selectedEmailServers = "" + newEntry.id;
		}
	}
	handleAddPlaceholder = (placeholder, id) => {
		this.setState({
			[id]: this.state[id] + placeholder
		});
	}
	handleRemoveServerEmail = (event) => {
		if (this.selectedEmailServers.length == 0) {
			return
		}
		var newArray = [];
		var idArray = this.selectedEmailServers.split(',');
		for (var j = 0; j < this.state.emailAddressList.length; j++) {
			for (var i = 0; i < idArray.length; i++) {
				if (idArray[i] != this.state.emailAddressList[j].id) {
					newArray.push(this.state.emailAddressList[j]);
				}
			}
		}
		newArray.sort(this.sortServeremail);
		newArray = this.reOrder(newArray);
		this.setState({
			emailAddressList: newArray
		});
	}
	handleServerEmailUp = (event) => {
		if (this.selectedEmailServers.length == 0) {
			return
		}
		let newList = this.state.emailAddressList;
		this.selectedEmailServers.split(",").forEach(function (anId) {
			let foundIndex = newList.findIndex(a => a.id == anId);
			if (foundIndex != -1) {
				var address = newList[foundIndex];
				if (address.order == 1) {
					return newList;
				}
				let newOrder = address.order - 1;
				this.state.emailAddressList.forEach(
					function (emailAdd, i) {
						if (newOrder == emailAdd.order) {
							emailAdd.order++;
							newList[i] = emailAdd;
							return
						}
					}
				);
				address.order = newOrder;
				newList[foundIndex] = address
			}
		}.bind(this));
		this.setState({
			emailAddressList: newList
		});
	}
	handleServerEmailDown = (event) => {
		if (this.selectedEmailServers.length == 0) {
			return
		}
		let newList = this.state.emailAddressList;
		this.selectedEmailServers.split(",").forEach(function (anId) {
			let foundIndex = newList.findIndex(a => a.id == anId);
			if (foundIndex != -1) {
				var address = newList[foundIndex];
				if (address.order == newList.length) {
					return newList;
				}
				let newOrder = address.order + 1;
				this.state.emailAddressList.forEach(
					function (emailAdd, i) {
						if (newOrder == emailAdd.order) {
							emailAdd.order--;
							newList[i] = emailAdd;
							return
						}
					}
				);
				address.order = newOrder;
				newList[foundIndex] = address
			}
		}.bind(this));
		this.setState({
			emailAddressList: newList
		});
	}
	onSelectDueDateArea = (id) => {
		this.setState({
			dueDateAreaId: id
		});
	}
	handleToggleArea = () => {
		this.setState({
			showArea: !this.state.showArea
		});
	}
	handleFileUpload = (data) => {
		this.setState({
			uploadFileName: data.value,
			uploadLocalFileName: data.id,
			isUploading: false,
			isProcessing: true,
			uploadProgress: I("File uploaded successfully! Processing areas in background...")
		});
		
		// Start polling for import status
		this.startAreaImportStatusPolling();
	}
	
	handleUploadProgress = (isUploading) => {
		this.setState({
			isUploading: isUploading,
			uploadProgress: isUploading ? I("Uploading file...") : ""
		});
	}
	
	// Area import status polling methods
	startAreaImportStatusPolling = () => {
		// Clear any existing interval
		if (this.importInterval) {
			clearInterval(this.importInterval);
		}
		
		// Start checking import status
		this.checkAreaImportStatus();
		
		// Set up polling interval
		this.importInterval = setInterval(() => {
			this.checkAreaImportStatus();
		}, 2000); // Check every 2 seconds
	}
	
	checkAreaImportStatus = () => {
		$.get(webserverRoot + "admin/org/area/areaImportStatus")
			.done((response) => {
				if (response.state && response.state.length > 0) {
					// Still processing
					this.setState({
						uploadProgress: I("Processing {COUNT} areas... Please wait.").replace('{COUNT}', response.state.length)
					});
				} else {
					// Processing complete
					this.setState({
						isProcessing: false,
						uploadProgress: I("Area processing completed! Refreshing page...")
					});
					
					// Clear the interval
					if (this.importInterval) {
						clearInterval(this.importInterval);
						this.importInterval = null;
					}
					
					// Refresh the page after a short delay
					setTimeout(() => {
						window.location.reload();
					}, 1500);
				}
			})
			.fail((error) => {
				console.error("Error checking area import status:", error);
				this.setState({
					isProcessing: false,
					uploadProgress: I("Error checking import status. Please refresh the page manually.")
				});
				
				if (this.importInterval) {
					clearInterval(this.importInterval);
					this.importInterval = null;
				}
			});
	}
	
	handleFeedbackDelay = (event) => {
		this.setState({
			feedbackSendOutDelay: event.target.value
		});
	}
	handleBlackoutPeriodAfterSurvey = (event) => {
		this.setState({
			blackoutPeriodAfterSurvey: event.target.value
		});
	}
	handleChangeData = (a, b) => {
		const name = b;
		this.setState({
			[name]: a
		});
	}
	
// Add after the handleChangeData method
	componentDidUpdate(prevProps, prevState, snapshot) {
		// Use snapshot if provided from getSnapshotBeforeUpdate
		// Handle any post-update logic for React 18 compatibility
		if (snapshot !== null) {
			// Use the snapshot value (e.g., restore scroll position)
			console.log("Snapshot from before update:", snapshot);
		}
		
		// Check for specific prop changes that need handling
		if (prevProps.area !== this.props.area) {
			// Clear memoization cache on props change
			if (this._memoizedValues) {
				this._memoizedValues.clear();
			}
		}
	}
	
// Add after componentDidUpdate
	componentWillUnmount() {
		// Clean up any subscriptions, timers, or event listeners to prevent memory leaks
		// Also clear any memoization cache
		if (this._memoizedValues) {
			this._memoizedValues.clear();
			this._memoizedValues = null;
		}
		
		// Clean up import status polling interval
		if (this.importInterval) {
			clearInterval(this.importInterval);
			this.importInterval = null;
		}
	}
	
// Add error boundary support
	componentDidCatch(error, errorInfo) {
		// Log the error to an error reporting service
		console.error("Error in AreaForm component:", error, errorInfo);
		// You could also set error state here to render a fallback UI
		this.setState({
			hasError: true,
			errorMessage: error.toString()
		});
	}
	
	// Add shouldComponentUpdate method
	shouldComponentUpdate(nextProps, nextState) {
		// Optimize rendering for React 18
		// Only update if props.area or relevant state has changed
		const areaChanged = this.props.area !== nextProps.area;
		const stateChanged = JSON.stringify(this.state) !== JSON.stringify(nextState);
		
		return areaChanged || stateChanged;
	}
	
	// Add getSnapshotBeforeUpdate for React 18
	getSnapshotBeforeUpdate(prevProps, prevState) {
		// Capture information from the DOM before it potentially changes
		// Return value will be passed as third parameter to componentDidUpdate
		// This is useful for saving things like scroll position
		return null;
	}
	
	// Add error rendering to the top of render method
	render = () => {
		// Add error handling for React 18 compatibility
		if (this.state.hasError) {
			return (
				<div className="error-boundary">
					<h2>Something went wrong.</h2>
					<details>
						<summary>Error details</summary>
						<p>{this.state.errorMessage}</p>
					</details>
					<button
						onClick={() => this.setState({ hasError: false, errorMessage: null })}
						className="btn btn-primary btn-sm"
					>
						Try again
					</button>
				</div>
			);
		}
		
		const p = this.props.area;
		const s = this.state;
		
		// Memoize static data that doesn't need to be recalculated on every render
		const receiveActions = this.getMemoizedValue('receiveActions', () => [
			{ id: 0, value: I('No') }, 
			{ id: 1, value: I('Yes') }, 
			{ id: 2, value: I('Time Interval') }
		]);
		
		const reoccurActions = this.getMemoizedValue('reoccurActions', () => [
			{ id: 0, value: I('No') }, 
			{ id: 1, value: I('Yes') }
		]);
		
		const dueDate = this.getMemoizedValue('dueDate', () => [
			{ id: 0, value: I('No') }, 
			{ id: 1, value: I('Yes') }
		]);
		
		// Memoize interval options
		const intervalDateOptions = this.getMemoizedValue('intervalDateOptions', () => {
			const options = [];
			for (let i = 1; i < 30; i++) {
				options.push(<option key={i} value={i}>{i}</option>);
			}
			return options;
		});

		var uploadUrl = "admin/org/" + s.organisationId + "/uploadAreaList";
		if (p === 'undefined')
			return null;
		if (p.timezoneList && p.timezoneList[0].id !== 0) {
			p.timezoneList.unshift({ abbrZoneName: "ORG", id: 0, label: "Use Organisation Setting", zoneName: "Org/Setting" });
		}
		let receiptAddress = <div className="form-group-org">
			<label className="col-sm-12 col-md-2">{I("Receipt address")}:<span className="mandatory">* </span></label>
			<div className="col-sm-8 col-md-3">
				<input name="receiptEmailAddress" className="form-control input-sm" type="text" value={s.receiptEmailAddress} onChange={this.handleInputChange} />
			</div>
		</div>;

		return (<div className="area-form">
			<div className="row select-row">
				<div className="col-lg-6">
					<div className="form-group-org">
						<div className="col-lg-12">
							<SelectInputRow
								id="organisationId"
								name="organisationId"
								className="organisationId"
								label={I('Organization')}
								option={formatValueToNameObj(p.organisationList, "id", "name")}
								value={s.organisationId}
								onSelect={this.handleChangeData}
							/>
						</div>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="form-group-org">
						<label className="col-lg-12">{I("Name")}:<span className="mandatory">* </span></label>
						<div className="col-lg-12">
							<input name="name" className="form-control input-sm" type="text" value={s.name} onChange={this.handleInputChange} />
						</div>
						<label style={{ display: (this.state.showNameError ? 'block' : 'none'), color: 'red' }} className="col-lg-6">{I("Name field can't be empty")}</label>
					</div>
				</div>
			</div>
			<div className="row select-row">
				<Feature tag="cention-workflow">
					<div className="col-lg-6">
						<div>
							<div className="form-group-org">
								<label className="col-lg-12">{I("Reply-to address")}:<span className="mandatory">* </span></label>
								<div className="col-lg-12">
									<input name="replyToEmailAddress" className="form-control input-sm" type="text" value={s.replyToEmailAddress} onChange={this.handleInputChange} />
								</div>
								<label style={{ display: (this.state.showReplyToError ? 'block' : 'none'), color: 'red' }} className="col-lg-6">{I("Reply-to address field must not be empty")}</label>
							</div>
						</div>
					</div>
				</Feature>
				<div className="col-lg-6">
					<div className="form-group-org">
						<label className="col-lg-12">{I("Name in reply-to address")}:</label>
						<div className="col-lg-12">
							<input name="replyToName" className="form-control input-sm" type="text" value={s.replyToName} onChange={this.handleInputChange} />
						</div>
					</div>
				</div>
			</div>
			<Feature tag="cention-workflow">
				{!p?.id && (
					<div style={{ display: "block" }}>
					<div className="form-group-org">
						<label className="col-sm-12 col-md-2">
						{I("Upload Area List")}:
						</label>
						<div className="col-sm-12 col-md-10">
							<table>
								<tbody>
									<tr>
										<td style={{ padding: "0 10px 0 0" }}>
											{(this.state.isUploading || this.state.isProcessing) ? (
												<button className="btn btn-default btn-file btn-fileupload" disabled>
													<i className="fa fa-upload"></i> {I("Browse")} ({I("Processing...")})
												</button>
											) : (
											<FileUploader uploadTo={uploadUrl}
													onFileupload={this.handleFileUpload}
													onProgress={this.handleUploadProgress} />
											)}
										</td>
										<td style={{ padding: "0 10px 0 0" }}>
											<input name="uploadFileName" className="form-control input-sm" type="text" value={this.state.uploadFileName} readOnly />
										</td>
										<td>
											<Helper helper={I("Create a csv file to upload with the following information:")
												+ I("Area name, email address, name in reply-to address") + "<br />"
												+ I("All information should be put in one column (if done in Excel) and comma separated.") + "<br />"
												+ I("Example:") + "<br />"
												+ I("Sales, info@cention.com, Cention Sales Support, support@cention.com, Cention Support")
											} />
										</td>
									</tr>
								</tbody>
							</table>
							{(this.state.isUploading || this.state.isProcessing) && (
								<div style={{ marginTop: "10px" }}>
									<div className="alert alert-info" style={{ display: "flex", alignItems: "center" }}>
										{this.state.isUploading && (
											<div style={{ marginRight: "10px" }}>
												<i className="fa fa-spinner fa-spin"></i>
						</div>
										)}
										{this.state.isProcessing && (
											<div style={{ marginRight: "10px" }}>
												<i className="fa fa-cog fa-spin"></i>
											</div>
										)}
										<div>
											<strong>{this.state.uploadProgress}</strong>
											{this.state.isProcessing && (
												<div style={{ fontSize: "12px", marginTop: "5px", color: "#666" }}>
													{I("This may take a few minutes depending on the number of areas. Please do not close this page.")}
												</div>
											)}
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
					</div>
				)}
			</Feature>

			<Feature tag="cention-workflow">
				<Feature tag="show-time-zone">
					<div className="row select-row">
						<div className="col-lg-6">
							<div className="form-group-org">
								<div className="col-lg-12">
									{/* <select name="timeZoneId" value={s.timeZoneId} onChange={this.handleInputChange} className="form-control input-sm">
										<option value={0}>{I("Use Organization Setting")}</option>
										{p.timezoneList && p.timezoneList.map((tz) => <option key={tz.id} value={tz.id}>{tz.label}</option>)}
									</select> */}
									<SelectInputRow
										id="timezoneID"
										name="timeZoneId"
										className="usetimeZone"
										label={I('Time Zone')}
										option={formatValueToNameObj(p.timezoneList, "id", "label")}
										value={s.timeZoneId}
										onSelect={this.handleChangeData}
									/>
								</div>
							</div>
						</div>
					</div>
				</Feature>
			</Feature>
			<Feature tag="cention-workflow">
				<div className="field-row">
					<div className="form-group-org td-padding-right">
						<div className="row">
							<label className="col-lg-12">{I("Hold time for 'My errands'")}:</label>
						</div>
						<div className="row">
							<div className="col-lg-12">
								<table>
									<tbody>
										<tr>
											<td><input name="errandExpireTime_days" className="form-control input-sm" type="text" value={s.errandExpireTime ? s.errandExpireTime.days : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("days")}</td>
											<td><input name="errandExpireTime_hours" className="form-control input-sm" type="text" value={s.errandExpireTime ? s.errandExpireTime.hours : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("hours")}</td>
											<td><input name="errandExpireTime_mins" className="form-control input-sm" type="text" value={s.errandExpireTime ? s.errandExpireTime.mins : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("minutes")}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div className="form-group-org td-padding-right">
						<div className="row">
							<label className="col-lg-12">{I("Hold time for partly answered errands")}:</label>
						</div>
						<div className="row">
							<div className="col-lg-12">
								<table>
									<tbody>
										<tr>
											<td><input name="partialExpireTime_days" className="form-control input-sm" type="text" value={s.partialExpireTime ? s.partialExpireTime.days : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("days")}</td>
											<td><input name="partialExpireTime_hours" className="form-control input-sm" type="text" value={s.partialExpireTime ? s.partialExpireTime.hours : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("hours")}</td>
											<td><input name="partialExpireTime_mins" className="form-control input-sm" type="text" value={s.partialExpireTime ? s.partialExpireTime.mins : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("minutes")}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div className="form-group-org td-padding-right">
						<div className="row">
							<label className="col-lg-12">{I("Hold time for collaboration errands")}:</label>
						</div>
						<div className="row">
							<div className="col-lg-12">
								<table>
									<tbody>
										<tr>
											<td><input name="collabErrandExpireTime_days" className="form-control input-sm" type="text" value={s.collabErrandExpireTime ? s.collabErrandExpireTime.days : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("days")}</td>
											<td><input name="collabErrandExpireTime_hours" className="form-control input-sm" type="text" value={s.collabErrandExpireTime ? s.collabErrandExpireTime.hours : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("hours")}</td>
											<td><input name="collabErrandExpireTime_mins" className="form-control input-sm" type="text" value={s.collabErrandExpireTime ? s.collabErrandExpireTime.mins : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("minutes")}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div className="form-group-org td-padding-right">
						<div className="row">
							<label className="col-lg-12">{I("Warning time for partly answered errands")}:</label>
						</div>
						<div className="row">
							<div className="col-lg-12">
								<table>
									<tbody>
										<tr>
											<td><input name="partialReplyWarningInterval_days" className="form-control input-sm" type="text" value={s.partialReplyWarningInterval ? s.partialReplyWarningInterval.days : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("days")}</td>
											<td><input name="partialReplyWarningInterval_hours" className="form-control input-sm" type="text" value={s.partialReplyWarningInterval ? s.partialReplyWarningInterval.hours : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("hours")}</td>
											<td><input name="partialReplyWarningInterval_mins" className="form-control input-sm" type="text" value={s.partialReplyWarningInterval ? s.partialReplyWarningInterval.mins : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("minutes")}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div className="form-group-org td-padding-right">
						<div className="row">
							<label className="col-lg-12">{I("General warning time")}:</label>
						</div>
						<div className="row">
							<div className="col-lg-12">
								<table>
									<tbody>
										<tr>
											<td><input name="generalWarningExpireTime_days" className="form-control input-sm" type="text" value={s.generalWarningExpireTime ? s.generalWarningExpireTime.days : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("days")}</td>
											<td><input name="generalWarningExpireTime_hours" className="form-control input-sm" type="text" value={s.generalWarningExpireTime ? s.generalWarningExpireTime.hours : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("hours")}</td>
											<td><input name="generalWarningExpireTime_mins" className="form-control input-sm" type="text" value={s.generalWarningExpireTime ? s.generalWarningExpireTime.mins : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("minutes")}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div className="form-group-org td-padding-right">
						<div className="row">
							<label className="col-lg-12">{I("Expiration time for partly answered errands")}:</label>
						</div>
						<div className="row">
							<div className="col-lg-12">
								<table>
									<tbody>
										<tr>
											<td><input name="partialAlertTime_days" className="form-control input-sm" type="text" value={s.partialAlertTime ? s.partialAlertTime.days : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("days")}</td>
											<td><input name="partialAlertTime_hours" className="form-control input-sm" type="text" value={s.partialAlertTime ? s.partialAlertTime.hours : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("hours")}</td>
											<td><input name="partialAlertTime_mins" className="form-control input-sm" type="text" value={s.partialAlertTime ? s.partialAlertTime.mins : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("minutes")}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div className="form-group-org td-padding-right">
						<div className="row">
							<label className="col-lg-12">{I("General expire time")}:</label>
						</div>
						<div className="row">
							<div className="col-lg-12">
								<table>
									<tbody>
										<tr>
											<td><input name="generalExpireTime_days" className="form-control input-sm" type="text" value={s.generalExpireTime ? s.generalExpireTime.days : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("days")}</td>
											<td><input name="generalExpireTime_hours" className="form-control input-sm" type="text" value={s.generalExpireTime ? s.generalExpireTime.hours : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("hours")}</td>
											<td><input name="generalExpireTime_mins" className="form-control input-sm" type="text" value={s.generalExpireTime ? s.generalExpireTime.mins : ""} onChange={this.handleExpireTimeChange} /></td>
											<td>{I("minutes")}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				<div className="col-lg-12 col-sm-12">
					<div className="form-group-org">
						<label className="col-sm-12 col-lg-12">{I("Note")}:</label>
						<div className="col-sm-12 col-lg-12">
							{getCKEditorFlag() && (
								<CKEditor5Component
									id={"note"}
									ref={"note"}
									locationHash={window.location.hash}
									defaultFontFamily={s.features}
									defaultFontSize={s.features}
									spellLanguages={s.languages || []}
									defaultContent={s.note || ""}
									showResize={false}
									simpleToolbar={false}
									fileArchiveImages={s.archiveImages || []}
									showFileArchive={true}
									onChange={this.handleCkeditorChange}
									onKeydown={this.handleKeyDown}
								/>
							)}
							{!getCKEditorFlag() && (
								<Ckeditor
									id={"note"}
									ref={"note"}
									locationHash={window.location.hash}
									defaultFontFamily={s.features}
									defaultFontSize={s.features}
									spellLanguages={s.languages || []}
									defaultContent={s.note || ""}
									showResize={false}
									simpleToolbar={false}
									fileArchiveImages={s.archiveImages || []}
									onChange={this.handleCkeditorChange}
									onKeydown={this.handleKeyDown}
								/>
							)}
						</div>
					</div>
				</div>
					<div className="row">
						<div className="col-lg-6">
							<div className="form-group-org">
								<label className="col-lg-12">{I("External ID")}:</label>
								<div className="col-lg-12">
									<input name="externalId" className="form-control input-sm" type="text" value={s.externalId} onChange={this.handleInputChange} />
								</div>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="form-group-org">
								<label className="col-lg-12">{I("Pre subject")}:</label>
								<div className="col-lg-12">
									<input name="prefixSubject" className="form-control input-sm" type="text" value={s.prefixSubject} onChange={this.handleInputChange} />
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-6">
							<div className="form-group-org">
								<label className="col-lg-12">{I("External Chat ID")}:</label>
								<div className="col-lg-12">
									<input name="externalChatId" className="form-control input-sm" type="text" value={s.externalChatId} onChange={this.handleInputChange} />
								</div>
							</div>
						</div>
						<Feature tag="puzzel">
							<Feature tag="puzzel.area-vip-custom-value">
								<div className="col-lg-6">
									<div className="form-group-org">
										<label className="col-lg-12">{I("External queue vip score custom value")}:</label>
										<div className="col-lg-12">
											<input name="externalPriority" className="form-control input-sm" type="text" value={s.externalPriority} onChange={this.handleInputChange} />
										</div>
									</div>
								</div>
							</Feature>
						</Feature>
					</div>
					<Feature tag="callEnableTwilio">
						<div className="row">
							<div className="col-lg-6">
								<div className="form-group-org">
									<div className="col-lg-12">
										{p.outbound &&
											<SelectInputRow
												id="outboundPhoneId"
												name="outboundPhoneId"
												className="outboundPhoneId"
												label={I('Outbound Phone')}
												option={formatValueToNameObj(p.outbound.outboundList, "id", "name")}
												value={s.outboundPhoneId}
												onSelect={this.handleChangeData}
											/>}
									</div>
								</div>
							</div>
							<div className="col-lg-6">
								<ExtFwdNumber
									onChange={this.handleInputChange}
									value={s.extFwdNumber}
								/>
							</div>
						</div>
					</Feature>
					<Feature tag="quicksearch.enabled">
						<div className="row">
							<div className="col-lg-6">
								<div className="form-group-org">
									<label className="col-lg-12">{I("Enable Quick Search Integration")}:</label>
									<div className="col-lg-12">
										<SwitchCheckbox
											active={s.doQuickSearch}
											buttonClassName={""}
											id={"orgActiveSwitch"}
											name={"orgActive"}
											type="checkbox"
											onClick={() => { this.handleSwitchBoxCheck(s.doQuickSearch, "doQuickSearch") }}
										/>
									</div>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="form-group-org">
									<label className="col-lg-12">{I("Quick Search CircularId")}:</label>
									<div className="col-lg-12">
										<input name="quickSearchCircularId" className="form-control input-sm" type="text" value={s.quickSearchCircularId} onChange={this.handleInputChange} />
									</div>
								</div>
							</div>
						</div>
					</Feature>
				</div>
			</Feature >
			<Feature tag="chat">
				<div className="field-row">
					<div className="row">
						<div className="col-lg-6">
							<div className="form-group-org">
								<label className="col-sm-12 col-lg-12">{I("Available Chat Slot")}:</label>
								<div className="col-sm-12 col-lg-12">
									<input name="proActiveChat" className="form-control input-sm" type="text" value={s.proActiveChat} onChange={this.handleInputChange} />
								</div>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="form-group-org">
								<label className="col-sm-12 col-lg-12">{I("Has chat")}:</label>
								<div className="col-sm-12 col-lg-12">
									<SwitchCheckbox
										active={s.hasChat}
										buttonClassName={""}
										id={"orgActiveSwitch"}
										name={"orgActive"}
										type="checkbox"
										onClick={() => { this.handleSwitchBoxCheck(s.hasChat, "hasChat") }}
									/>
								</div>
							</div>
						</div>
					{features["whatsapp-history-7days"] &&(
						<div className="col-lg-6">
							<div className="form-group-org">
								<label className="col-sm-12 col-lg-12">{I("Has a seven-day WhatsApp history")}:</label>
								<div className="col-sm-12 col-lg-12">
									<SwitchCheckbox
										active={s.hasSevenDaysWhatsapp}
										buttonClassName={""}
										id={"orgActiveSwitch"}
										name={"orgActive"}
										type="checkbox"
										onClick={() => { this.handleSwitchBoxCheck(s.hasSevenDaysWhatsapp, "hasSevenDaysWhatsapp") }}
									/>
								</div>
							</div>
						</div>)}
						{features["facebook-admin-threads-close"] &&(
						<div className="col-lg-6">
							<div className="form-group-org">
								<label className="col-sm-12 col-lg-12">{I("Close Facebook comments and replies from administrator posts")}:</label>
								<div className="col-sm-12 col-lg-12">
									<SwitchCheckbox
										active={s.disableAdminFbPostComments}
										buttonClassName={""}
										id={"orgActiveSwitch"}
										name={"orgActive"}
										type="checkbox"
										onClick={() => { this.handleSwitchBoxCheck(s.disableAdminFbPostComments, "disableAdminFbPostComments") }}
									/>
								</div>
							</div>
						</div>
						 )} 
						<Feature tag="sip-enabled">
							<div className="col-lg-6">
								<div className="form-group-org">
									<label className="col-sm-12 col-lg-12">{I("Has voice")}:</label>
									<div className="col-sm-12 col-lg-12">
										<SwitchCheckbox
											active={s.hasVoice}
											buttonClassName={""}
											id={"orgActiveSwitch"}
											name={"orgActive"}
											type="checkbox"
											onClick={() => { this.handleSwitchBoxCheck(s.hasVoice, "hasVoice") }}
										/>
									</div>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="form-group-org">
									<label className="col-sm-12 col-lg-12">{I("Outgoing SIP trunk Id")}:</label>
									<div className="col-sm-12 col-lg-12">
										<input name="sipOutgoingDialPlanId" className="form-control input-sm" type="text" value={s.sipOutgoingDialPlanId} onChange={this.handleInputChange} />
									</div>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="form-group-org">
									<label className="col-sm-12 col-lg-12">{I("SIP Queue Id")}:</label>
									<div className="col-sm-12 col-lg-12">
										<input name="sipQueueId" className="form-control input-sm" type="text" value={s.sipQueueId} onChange={this.handleInputChange} />
									</div>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="form-group-org">
									<label className="col-sm-12 col-lg-12">{I("SIP Forward To Number")}:</label>
									<div className="col-sm-12 col-lg-12">
										<input name="sipExtFwdNumber" className="form-control input-sm" type="text" value={s.sipExtFwdNumber} onChange={this.handleInputChange} />
									</div>
								</div>
							</div>
						</Feature>
						<div className="col-lg-6">
							<div className="form-group-org">
								<label className="col-sm-12 col-lg-12">{I("Chat URL name")}:</label>
								<div className="col-sm-12 col-lg-12">
									<input name="chatAreaUrl" className="form-control input-sm" type="text" value={s.chatAreaUrl} onChange={this.handleInputChange} />
								</div>
							</div>
						</div>
						<Feature tag="chat.max-queued-sessions.admin-edit">
							<div className="col-lg-6">
								<div className="form-group-org">
									<label className="col-sm-12 col-lg-12">{I("Number of allowed queued chat sessions")}:</label>
									<div className="col-sm-12 col-lg-12">
										<input name="maxAllowedQueuedChatSessions" className="form-control input-sm" type="text" value={s.maxAllowedQueuedChatSessions} onChange={this.handleInputChange} />
									</div>
								</div>
							</div>
						</Feature>
						<Hideable hidden={PC_RECEIPT_GREETING}>
							<div className="col-lg-6">
								<div className="form-group-org">
									<label className="col-sm-12 col-lg-12">{I("Enable predefined chat message")}:</label>
									<div className="col-sm-12 col-lg-12">
										<SwitchCheckbox
											active={s.enabledPredefinedChatMessage}
											buttonClassName={""}
											id={"orgActiveSwitch"}
											name={"orgActive"}
											type="checkbox"
											onClick={() => { this.handleSwitchBoxCheck(s.enabledPredefinedChatMessage, "enabledPredefinedChatMessage") }}
										/>
									</div>
								</div>
							</div>
							{s.enabledPredefinedChatMessage &&
								<div className="col-lg-6">
									<div className="form-group-org">
										<label className="col-sm-12 col-lg-12">{I("Predefined chat message")}:</label>
										<div className="col-sm-12 col-lg-12">
											<input name="predefinedChatMessage" className="form-control input-sm" type="text" value={s.predefinedChatMessage} onChange={this.handleInputChange} />
										</div>
									</div>
								</div>
							}
						</Hideable>
					</div>
				</div>
			</Feature>
			<Feature tag="cention-workflow">
				<div className="field-row">
					<div className="row">
						<Feature tag="solidusEnabled">
							<div className="col-lg-6">
								<div className="form-group-org">
									<label className="col-lg-12">{I("Solidus Service Group ID")}:</label>
									<div className="col-lg-12">
										<input name="solidusServiceGroupId" className="form-control input-sm" type="text" value={s.solidusServiceGroupId} onChange={this.handleInputChange} />
									</div>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="form-group-org">
									<label className="col-lg-12">{I("Prioritized Solidus Service Group ID")}:</label>
									<div className="col-lg-12">
										<input name="solidusPriorityServiceGroupId" className="form-control input-sm" type="text" value={s.solidusPriorityServiceGroupId} onChange={this.handleInputChange} />
									</div>
								</div>
							</div>
							<Feature tag="chat">
								<div className="form-group-org">
									<label className="col-lg-11">{I("Solidus Service Group ID's for chat")}:</label>
									<div className="col-lg-11">
										<input name="solidusServiceGroupIdsForChat" className="form-control input-sm" type="text" value={s.solidusServiceGroupIdsForChat} onChange={this.handleInputChange} />
									</div>
									<div className="col-lg-1">
										<Helper helper={I("Here you can enter a comma separated list of Solidus Service Group IDs that should be checked for available agents when the system decides which agents a chat can be forwarded to.") + "<br />"
											+ I("If nothing is entered in this field the system will check the Service Group entered in the field above.")
										} />
									</div>
								</div>
							</Feature>
						</Feature>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-12">
						<div className="form-group-org">
					<label className="col-sm-12 col-lg-12">{I("Banner")}:</label>
					<div className="col-sm-12 col-lg-12">
						{getCKEditorFlag() && (
							<CKEditor5Component
								id={"defaultBanner"}
								ref={"defaultBanner"}
								locationHash={window.location.hash}
								defaultFontFamily={s.features}
								defaultFontSize={s.features}
								spellLanguages={s.languages || []}
								defaultContent={s.defaultBanner || ""}
								showResize={false}
								simpleToolbar={false}
								fileArchiveImages={s.archiveImages || []}
								showFileArchive={true}
								onChange={this.handleCkeditorChange}
								onKeydown={this.handleKeyDown}
							/>
						)}
								{!getCKEditorFlag() && (
									<Ckeditor
										id={"defaultBanner"}
										ref={"defaultBanner"}
										locationHash={window.location.hash}
										defaultFontFamily={s.features}
										defaultFontSize={s.features}
										spellLanguages={s.languages || []}
										defaultContent={s.defaultBanner || ""}
										showResize={false}
										simpleToolbar={false}
										fileArchiveImages={s.archiveImages || []}
										onChange={this.handleCkeditorChange}
										onKeydown={this.handleKeyDown}
									/>
								)}
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="form-group-org">
							<div className="col-sm-12 col-lg-12">
								<SelectInputRow
									id="defaultSalutation"
									name="defaultSalutation"
									className="defaultSalutation"
									label={I('Default Salutation')}
									option={formatValueToNameObj(p.salutationList, "id", "name")}
									value={s.defaultSalutation == "" ? 0 : s.defaultSalutation}
									onSelect={this.handleChangeData}
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="form-group-org">
							<label className="col-sm-12 col-lg-12">{I("Only administrators can change salutation")}:</label>
							<div className="col-sm-12 col-lg-12">
								<SwitchCheckbox
									active={s.onlyAdminCanChangeSalutation}
									buttonClassName={""}
									id={"orgActiveSwitch"}
									name={"orgActive"}
									type="checkbox"
									onClick={() => { this.handleSwitchBoxCheck(s.onlyAdminCanChangeSalutation, "onlyAdminCanChangeSalutation") }}
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="form-group-org">
							<div className="col-sm-12 col-lg-12">
								<SelectInputRow
									id="defaultSignature"
									name="defaultSignature"
									className="defaultSignature"
									label={I('Default Signature')}
									option={formatValueToNameObj(p.signatureList, "id", "name")}
									value={s.defaultSignature == "" ? 0 : s.defaultSignature}
									onSelect={this.handleChangeData}
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="form-group-org">
							<label className="col-sm-12 col-lg-12">{I("Only administrators can change signature")}:</label>
							<div className="col-sm-12 col-lg-12">
								<SwitchCheckbox
									active={s.onlyAdminCanChangeSignature}
									buttonClassName={""}
									id={"orgActiveSwitch"}
									name={"orgActive"}
									type="checkbox"
									onClick={() => { this.handleSwitchBoxCheck(s.onlyAdminCanChangeSignature, "onlyAdminCanChangeSignature") }}
								/>
							</div>
						</div>
					</div>
					<Feature tag="cention-library">
						<div className="col-lg-12 col-sm-12">
							<div className="form-group-org">
								{/* <label className="col-sm-12 col-lg-12">{I("Default Knowledge base")}:</label> */}
								<div className="col-sm-12 col-lg-12">
									{/* <select name="libraryId" value={s.libraryId} onChange={this.handleInputChange} className="form-control input-sm">
										{p.libraryList && p.libraryList.map((tz) => <option key={tz.id} value={tz.id}>{tz.name}</option>)}
									</select> */}
									<SelectInputRow
										id="libraryId"
										name="libraryId"
										className="libraryId"
										label={I('Default Knowledge base for agent')}
										option={formatValueToNameObj(p.libraryList, "id", "name")}
										value={s.libraryId}
										onSelect={this.handleChangeData}
									/>
								</div>
							</div>
						</div>
					</Feature>
					<Feature tag="external-experts">
						<div className="col-lg-6 col-sm-6">
							<div className="form-group-org">
								<label className="col-sm-12 col-lg-12">{I("External experts answers by email")}:</label>
								<div className="col-sm-12 col-lg-12">
									<SwitchCheckbox
										active={s.externalExpertsByEmail}
										buttonClassName={""}
										id={"orgActiveSwitch"}
										name={"orgActive"}
										type="checkbox"
										onClick={() => { this.handleSwitchBoxCheck(s.externalExpertsByEmail, "externalExpertsByEmail") }}
									/>
								</div>
							</div>
						</div>
						<div className="col-lg-6 col-sm-6">
							<div className="form-group-org">
								<label className="col-sm-12 col-lg-12">{I("External experts from address")}:</label>
								<div className="col-sm-12 col-lg-12">
									<input name="externalExpertFrom" className="form-control input-sm" type="text" value={s.externalExpertFrom} onChange={this.handleInputChange} />
								</div>
							</div>
						</div>
						<div className="col-lg-6 col-sm-6">
							<div className="form-group-org">
								<label className="col-sm-12 col-lg-12">{I("Pre-filled external experts address")}:</label>
								<div className="col-sm-12 col-lg-12">
									<input name="preFilledExternalExpert" className="form-control input-sm" type="text" value={s.preFilledExternalExpert} onChange={this.handleInputChange} />
								</div>
							</div>
						</div>
					<div className="col-lg-12 col-sm-12">
						<div className="form-group-org">
					<label className="col-sm-12 col-lg-12">{I("Note to external experts")}:</label>
					<div className="col-sm-12 col-lg-12">
						{getCKEditorFlag() && (
							<CKEditor5Component
								id={"noteToExternalExperts"}
								ref={"noteToExternalExperts"}
								locationHash={window.location.hash}
								defaultFontFamily={s.features}
								defaultFontSize={s.features}
								spellLanguages={s.languages || []}
								defaultContent={s.noteToExternalExperts || ""}
								showResize={false}
								simpleToolbar={false}
								fileArchiveImages={s.archiveImages || []}
								showFileArchive={true}
								onChange={this.handleCkeditorChange}
								onKeydown={this.handleKeyDown}
							/>
						)}
								{!getCKEditorFlag() && (
									<Ckeditor
										id={"noteToExternalExperts"}
										ref={"noteToExternalExperts"}
										locationHash={window.location.hash}
										defaultFontFamily={s.features}
										defaultFontSize={s.features}
										spellLanguages={s.languages || []}
										defaultContent={s.noteToExternalExperts || ""}
										showResize={false}
										simpleToolbar={false}
										fileArchiveImages={s.archiveImages || []}
										onChange={this.handleCkeditorChange}
										onKeydown={this.handleKeyDown}
									/>
								)}
							</div>
						</div>
					</div>
					</Feature>
					<Feature tag="satisfaction-feedback">
						<div className="col-lg-12 satisfaction-feedback">
							<div className="form-group-org">
								<label className="col-sm-12 col-lg-12">{I("Delay for sending Satisfaction meter email")}:</label>
								<div className="col-sm-6 col-lg-6">
									<input type="number" min="0" className="form-control input-sm" value={s.feedbackSendOutDelay} onChange={this.handleFeedbackDelay} />
									{I("hours")}
								</div>
							</div>
						</div>
					</Feature>
					<Feature tag="satisfaction-feedback">
						<CFlag flag="2023-11-20.CEN-1038.blackout.period.after.sent.survey">
							<div className="col-lg-12 blackout-period-after-sent-survey">
								<div className="form-group-org">
									<label className="col-sm-12 col-lg-12">{I("Blackout period after sent survey")}:</label>
									<div className="col-sm-6 col-lg-6">
										<input type="number" min="0" className="form-control input-sm" value={s.blackoutPeriodAfterSurvey} onChange={this.handleBlackoutPeriodAfterSurvey} />
										{I("hours")}
									</div>
								</div>
							</div>
						</CFlag>
					</Feature>

					<Feature tag="postpone-done-date">
						<div className="col-lg-12">
							<div className="form-group-org">
								<label className="col-sm-12 col-lg-12">{I("Enable postponed errands")}:</label>
								<div className="col-lg-1">
									<SwitchCheckbox
										active={s.hasPostpone}
										buttonClassName={""}
										id={"orgActiveSwitch"}
										name={"orgActive"}
										type="checkbox"
										onClick={() => { this.handleSwitchBoxCheck(s.hasPostpone, "hasPostpone") }}
									/>
								</div>
								<div className="col-lg-1">
									<Helper helper={I("Tick for allowing this area to be used for Postpone errands. Errands can then be postponed to this area and will be moved back to the original area when the due date is reached.")} />
								</div>
							</div>
						</div>
					</Feature>
					<Feature tag="expected-done-date">
						<div className="due-date">
							<div className="col-lg-12">
								<div className="form-group-org">
									{/* <label className="col-lg-12">{I("Due date")}:</label> */}
									<div className="col-lg-6">
										{/* <select name="dueDate_dueDateSelected" value={s.dueDate.dueDateSelected} onChange={this.handleSubInputChangeInt} className="form-control input-sm">
											{dueDate.map((a) => <option key={a.id} value={a.id}>{a.value}</option>)}
										</select> */}
										<SelectInputRow
											id="dueDate_dueDateSelected"
											name="dueDate_dueDateSelected"
											className="dueDate_dueDateSelected"
											label={I('Due date')}
											option={formatValueToNameObj(dueDate, "id", "value")}
											value={s.dueDate.dueDateSelected}
											onSelect={this.handleChangeSubData}
										/>
									</div>
								</div>
							</div>
							{s.dueDate.dueDateSelected == 1 && <div id="due_date">
								<div className="margin-collapse-row row" style={{ display: "block" }}>
									<div className="col-lg-6">
										<div className="form-group-org">
											<label className="col-sm-12 col-lg-12">{I("Due Date address")}:</label>
											<div className="col-sm-12 col-lg-12">
												<input name="dueDate_doneDateAddress" className="form-control input-sm" type="text" value={s.dueDate.doneDateAddress} onChange={this.handleSubInputChange} />
											</div>
										</div>
									</div>
									<div className="col-lg-6">
										<div className="form-group-org">
											<label className="col-sm-12 col-lg-12">{I("Due date reminder")}:</label>
											<div className="col-lg-2">
												<SwitchCheckbox
													active={s.dueDate.hasDoneDateNotification}
													buttonClassName={""}
													id={"orgActiveSwitch"}
													name={"orgActive"}
													type="checkbox"
													onClick={() => { this.handleSubSwitchBoxCheck(s.dueDate.hasDoneDateNotification, "dueDate_hasDoneDateNotification") }}
												/>
											</div>
											<div className="col-lg-1">
												<Helper helper={I("Allows notification to be sent to agent owning the errand when it is 2 days before the errand's due date.")} />
											</div>
										</div>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="form-group-org">
										<label className="col-sm-12 col-lg-12">{I("Move to area when errand is due")}:</label>
										<div className="area-dropdown-v5">
											<SingleSelectDD
												id={"manual-errand-areas"}
												textNoItemSelected={I("Select area")}
												className={"popup-multi-select"}
												nested={{ key: 'Areas' }}
												data={s.areaList}
												idFields={{ id: "Id", name: "Name" }}
												selected={s.dueDateAreaId}
												onSelect={this.onSelectDueDateArea}
												isHeader={true}
												onToggle={this.handleToggleArea}
												show={this.state.showArea}
												selectNone={true}
												selectAll={false}
											/>
										</div>
										<div className="col-lg-1">
											<Helper helper={I("Moves errand to specified area 1 day before the errand's due date. If there is less than 24 hours until a day before due date, the errand will not be moved.")} />
										</div>
									</div>
								</div>
								<div className="col-lg-12">
									<div className="form-group-org">
										<label className="col-lg-3">{I("Due Date Note")}:</label>
										<div className="col-lg-1">
											<Helper helper={I("Enter the text that should be sent out in the notification to the customer stating when their errand will be handled.")
												+ "<br />"
												+ I("You can use the following templates:")
												+ "<ul>"
												+ "<li><b>{DUEDATE}</b><br />"
												+ I("Shows the date the agent chose for the errand.")
												+ "</li>"
												+ "</ul>"
											} />
										</div>
								<div className="col-lg-12">
									{getCKEditorFlag() && (
										<CKEditor5Component
											id={"dueDate_expectedDoneDateNote"}
											ref={"dueDate_expectedDoneDateNote"}
											locationHash={window.location.hash}
											defaultFontFamily={s.features}
											defaultFontSize={s.features}
											spellLanguages={s.languages || []}
											defaultContent={s.dueDate.expectedDoneDateNote}
											showResize={false}
											simpleToolbar={false}
											fileArchiveImages={s.archiveImages || []}
											showFileArchive={true}
											onChange={this.handleSubCkeditorChange}
											onKeydown={this.handleKeyDown}
										/>
									)}
										{!getCKEditorFlag() && (
											<Ckeditor
												id={"dueDate_expectedDoneDateNote"}
												ref={"dueDate_expectedDoneDateNote"}
												locationHash={window.location.hash}
												defaultFontFamily={s.features}
												defaultFontSize={s.features}
												spellLanguages={s.languages || []}
												defaultContent={s.dueDate.expectedDoneDateNote}
												showResize={false}
												simpleToolbar={false}
												fileArchiveImages={s.archiveImages || []}
												onChange={this.handleSubCkeditorChange}
												onKeydown={this.handleKeyDown}
											/>
										)}
									</div>

									</div>
								</div>
							</div>}
						</div>
					</Feature>
				</div>
			</Feature >
			<div className="row">
				<div className="col-lg-6">
					<div className="form-group-org">
						<label className="col-sm-12 col-lg-12">{I("Delete all errands in the area")}:</label>
						<div className="col-sm-12 col-lg-12">
							<SwitchCheckbox
								active={s.removeErrandFromArea}
								buttonClassName={""}
								id={"orgActiveSwitch"}
								name={"orgActive"}
								type="checkbox"
								onClick={() => { this.handleSwitchBoxCheck(s.removeErrandFromArea, "removeErrandFromArea") }}
							/>
						</div>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="form-group-org">
						<label className="col-sm-12 col-lg-12">{I("Days until deleting")}:</label>
						<div className="col-lg-10">
							<input name="daysToKeepErrand" className="form-control input-sm" type="text" value={s.daysToKeepErrand} onChange={this.handleInputChange} />
						</div>
						<div className="col-lg-1">
							<Helper helper={I("Effective only if Delete all errands in the area is enabled. If set to 0, all incoming errands in the area will be deleted immediately. Errands forwarded to the area by an agent will be deleted once per day.")} />
						</div>
					</div>
				</div>
			</div>
			<PCI
				onSelect={this.handlePCIAutoDeleteAttachments}
				options={reoccurActions}
				value={this.state.pci}
			/>
			<PCIHoursKeepAttachment
				onChange={this.handleChangePCIHoursKeepAttachment}
				value={this.state.pci}
			/>
			<div className="row">
				<div className="col-lg-12 agent-list-dropdown">
					<div className="form-group-org">
						<label className="col-xs-12 col-sm-12 col-lg-12">{I("Agent groups")}:</label>
						<div className="col-lg-5" style={{ paddingRight: "0px" }}>
							<DropDown
								id="all"
								name={I("All")}
								type={"list-multiselect"}
								items={s.agentGroupListing}
								selectedItems={this.selectedAvailableGroups}
								align="left"
								fields={{ id: "id", name: "name" }}
								onChange={this.onSelectAvailable}
								activeWhen="Active"
								multiSelect={true}
								wantSelectAll={true}
								wantSelectNone={true}
							/>
						</div>
						<div className="col-lg-2 textAlignCenter btn-group-vertical" style={{ padding: "5px 20px" }}>
							<span><a className="btn btn-default text-center" onClick={this.handleAddGroups}>{">"}</a></span>
							<p />
							<span><a className="btn btn-default text-center" onClick={this.handleRemoveGroups}>{"<"}</a></span>
						</div>
						<div className="col-lg-5" style={{ paddingLeft: "0px" }}>
							<DropDown
								id="members"
								name={I("Members")}
								type={"list-multiselect"}
								items={s.agentGroupSelected}
								selectedItems={this.selectedAddedMembers}
								align="left"
								fields={{ id: "id", name: "name" }}
								onChange={this.onSelectGroup}
								activeWhen="Active"
								multiSelect={true}
								wantSelectAll={true}
								wantSelectNone={true}
							/>
						</div>
					</div>
					<div className="form-group-org">
						<div className="margin-collapse-row row" style={{ display: "block" }}>
							<label className="col-lg-4">{I("Server emails")}:</label>
							<div className="col-lg-1">
								<Helper helper={I("Add aliases associated with the area's email address. Addresses added here will not be sent to when using \"Reply to all\". When opening an errand, the addresses here will be presented in the same priority order as in this list.")} />
							</div>
						</div>
						<div className="margin-collapse-row row" style={{ display: "block" }}>
							<div className="col-lg-5" style={{ paddingRight: "5px"}}>
								<input name="newServerEmail" className="form-control input-sm" type="text" value={s.newServerEmail} onChange={this.handleInputChange} />
								<DropDown
									id="serverEmailList"
									name={I("Emails")}
									type={"list-multiselect"}
									items={this.state.emailAddressList}
									selectedItems={this.selectedEmailServers}
									align="left"
									fields={{ id: "id", name: "name" }}
									onChange={this.onSelectEmailServer}
									activeWhen="true"
									multiSelect={false}
									singleSelect={true}
									sort={true}
									customSort={this.sortServerEmail}
								/>
							</div>
							<div className="col-lg-2 nopadding textAlignCenter btn-group-vertical">
								<span><a className="btn btn-default text-center" onClick={this.handleAddServerEmail}><i className="icon-add"></i></a></span>
								<p />
								<span><a className="btn btn-default text-center" onClick={this.handleRemoveServerEmail}><i className="icon-trash"></i></a></span>
								<p />
								<span><a className="btn btn-default text-center" onClick={this.handleServerEmailUp}><i className="icon-chevron-up"></i></a></span>
								<p />
								<span><a className="btn btn-default text-center" onClick={this.handleServerEmailDown}><i className="icon-chevron-down"></i></a></span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Feature tag="data-protection.anonymize">
				<div className="row">
					<div className="col-lg-6">
						<div className="form-group-org">
							<label className="col-lg-12 col-sm-12">{I("Exclude for Right to be forgotten")}:</label>
							<div className="col-sm-2 col-lg-2">
								<SwitchCheckbox
									active={s.excludeAnonymize}
									buttonClassName={""}
									id={"orgActiveSwitch"}
									name={"orgActive"}
									type="checkbox"
									onClick={() => { this.handleSwitchBoxCheck(s.excludeAnonymize, "excludeAnonymize") }}
								/>
							</div>
							<div className="col-lg-2 col-sm-2">
								<Helper helper={I("Enable this option to prevent errand from anonymize")} />
							</div>
						</div>
					</div>

					{!s.excludeAnonymize &&
						<div className="col-lg-6">
							<div className="form-group-org">
								<label className="col-lg-12 col-sm-12">{I("Days until anonymize")}:</label>
								<div className="col-lg-10">
									<input name="anonymizeDay" className="form-control input-sm" type="text" value={s.anonymizeDay} onChange={this.handleInputChange} />
								</div>
								<div className="col-lg-1">
									<Helper helper={I("Number of days before errands are anonymized. Put 0 for no anonymize")} />
								</div>
							</div>
						</div>
					}
					{!s.excludeAnonymize && s.anonymizeDay != 0 &&
						<div className="col-lg-6">
							<div className="form-group-org">
								<label className="col-lg-12 col-sm-12">{I("Anonymize contact details")}:</label>
								<div className="col-lg-10">
									<SwitchCheckbox
										active={s.anonymizeContact}
										buttonClassName={""}
										id={"orgActiveSwitch"}
										name={"orgActive"}
										type="checkbox"
										onClick={() => { this.handleSwitchBoxCheck(s.anonymizeContact, "anonymizeContact") }}
									/>
								</div>
								<div className="col-lg-1">
									<Helper helper={I("Enable to anonymize contact details during schedule anonymize process")} />
								</div>
							</div>
						</div>
					}
				</div>
			</Feature>
			<div className="form-group editPageActionButton">
				<div className="row">
					<div className="col-lg-12 textAlignRight">
						<CancelButton onClick={this.props.cancel} />
						<SaveButton
							key="btn-save-admin"
							onClick={() => { this.saveArea() }}
							text={this.props.saving ? BTN_TXT_SAVING : BTN_TXT_SAVE}
							disabled={this.props.saving}
						/>
					</div>
				</div>
			</div>
		</div >);
	}
	saveButton = () => {
		if (!this.props.saving) {
			return <button className="btn btn-primary btn-sm" type="button" onClick={this.saveArea}>{BTN_TXT_SAVE}</button>
		}
		return <button className="btn btn-primary btn-sm" type="button">{BTN_TXT_SAVING}</button>
	}
	
	// Add after getMemoizedValue method
	getMemoizedValue(key, calculateFn) {
		// Simple memoization implementation for class components 
		if (!this._memoizedValues) {
			this._memoizedValues = new Map();
		}
		
		if (!this._memoizedValues.has(key)) {
			this._memoizedValues.set(key, calculateFn());
		}
		
		return this._memoizedValues.get(key);
	}
	
	// Add memoized event handler method
	getMemoizedHandler(key, handler) {
		// Create a memoized version of event handlers (similar to useCallback)
		return this.getMemoizedValue(`handler_${key}`, () => handler);
	}
}
